import axios from 'axios';
import Cookies from 'js-cookie';
import store from '../store';
import router from '../router';
import Swal from 'sweetalert2';
import logoutImage from '@/assets/images/logout.png';

const APICall = {
  install(app) {
    app.config.globalProperties.$call = {
      urlApi: import.meta.env.VITE_APP_API,
      //ChackPersonalInfo(callback, error) {
      //  var request = null;
      //  this.apiPostLogin('api/v0/SSO/ChackPersonalInfo', request, callback, error);
      //},
      Login(request, callback, error) {
        this.apiPostLogin('api/v0/Login/Login', request, callback, error);
      },
      LoginLHB(request, callback, error) {
        this.apiPostLoginLHB('api/v1/LHB/GetTokenChatLHBAdmin', request, callback, error);
      },
      AutoLogin(request, callback, error) {
        this.apiPostAuth('api/v0/Login/AutoLogin', request, callback, error);
      },
      ForgetPassword(param, callback, error) {
        this.apiGetAuth(`api/v0/Login/ForgetPassword?email=${param}`, callback, error);
      },
      ChatLogin(request, callback, error) {
        this.apiPostLoginChat('api/v0/Login/ChatLogin', request, callback, error);
      },
      CheckStatusSSO(request, callback, error) {
        this.apiPostAuth('api/v0/SSO/CheckStatusSSO', request, callback, error);
      },
      loginMicrosoft(callback, error) {
        this.apiGetAuth('api/v0/SSO/SignInChat', callback, error);
      },
      GetUserProfile(callback, error) {
        var request = null;
        this.apiPostAuth('api/v0/SSO/GetUserProfile', request, callback, error);
      },
      GetUserChatProfile(callback, error) {
        var request = null;
        this.apiPostAuth('api/v0/SSO/GetUserChatProfile', request, callback, error);
      },
      SaveAgreeConsent(request, callback, error) {
        this.apiPostAuth('api/v0/User/SaveAgreeConsent', request, callback, error);
      },

      //UserManagement
      GetTableUserManagement(request, callback, error) {
        this.apiPostAuth('api/v0/User/GetTableUserManagement', request, callback, error);
      },
      CreateUser(request, callback, error) {
        this.apiPostAuth('api/v0/User/CreateUser', request, callback, error);
      },
      UpdateUser(request, callback, error) {
        this.apiPostAuth('api/v0/User/UpdateUser', request, callback, error);
      },
      UpdateUserProfile(request, callback, error) {
        this.apiPostAuth('api/v0/User/UpdateUserProfile', request, callback, error);
      },
      DeleteUser(param, callback, error) {
        this.apiDeleteAuth('api/v0/User/DeleteUser?id=' + param, callback, error);
      },
      SaveChangePassword(request, callback, error) {
        this.apiPostAuth('api/v0/User/SaveChangePassword', request, callback, error);
      },
      ChangePassword(request, callback, error) {
        this.apiPostAuth('api/v0/User/ChangePassword', request, callback, error);
      },
      GetTableUserChatManagement(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/GetTableUserManagement', request, callback, error);
      },
      CreateUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/CreateUser', request, callback, error);
      },
      UpdateUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/UpdateUser', request, callback, error);
      },
      DeleteUserChat(param, callback, error) {
        this.apiDeleteAuth('api/v0/UserChat/DeleteUser?id=' + param, callback, error);
      },
      SaveChangePasswordUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/SaveChangePasswordUserChat', request, callback, error);
      },
      DownloadTemplateUser(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/User/DownloadTemplateUser', request, callback, error);
      },
      ImportUser(request, Config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/User/ImportUser?isUserChat=${request.isUserChat}`, request.entity, Config, callback, error);
      },
      SyncUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/SSO/SyncUserAzure', request, callback, error);
      },

      //BlacklistChatUser
      GetTableBlacklistChatUserManagement(request, callback, error) {
        this.apiPostAuth('api/v0/BlacklistChatUser/GetTableBlacklistChatUserManagement', request, callback, error);
      },
      GetLineUserID(callback, error) {
        this.apiGetAuth('api/v0/BlacklistChatUser/GetLineUserID', callback, error);
      },
      SetBlacklistChatUser(request, callback, error) {
        this.apiPostAuth('api/v0/BlacklistChatUser/SetBlacklistChatUser', request, callback, error);
      },
      DeleteBlacklistChatUser(request, callback, error) {
        this.apiPostAuth('api/v0/BlacklistChatUser/DeleteBlacklistChatUser', request, callback, error);
      },

      //GPTModel Management
      GetTableGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/GetTableGPTModel', request, callback, error);
      },
      GetTableGPTModelVersioning(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/GetTableGPTModelVersioning', request, callback, error);
      },
      GetGPTModelById(param, callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModel/GetGPTModelById?id=${param}`, callback, error);
      },
      PublishGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/PublishGPTModel', request, callback, error);
      },
      ReplaceGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/ReplaceGPTModel', request, callback, error);
      },
      AddGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/AddGPTModel', request, callback, error);
      },
      UpdateGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/UpdateGPTModel', request, callback, error);
      },
      DeleteGPTModel(param, callback, error) {
        this.apiDeleteAuth('api/v0/ManageGPTModel/DeleteGPTModel?id=' + param, callback, error);
      },
      DDGPTModel(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/DDGPTModel', callback, error);
      },
      DDGPTModelIsPublish(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/DDGPTModel_IsPublish', callback, error);
      },
      DDGPTModel_IsPublishByUser(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/DDGPTModel_IsPublishByUser', callback, error);
      },
      GetAllDDModelManagement(id, callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/GetDataForConfigModel?id=' + id, callback, error);
      },
      GetDDLModelDataAzureProvider(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/GetDDLModelDataAzureProvider', callback, error);
      },
      ExportFileConfigModel(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/ManageGPTModel/ExportFileConfigModel`, request, callback, error);
      },
      ImportFileModelConfig(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/ImportFileModelConfig', request, callback, error);
      },
      SummarizeGPTModelChanges(request, id, callback, error) {
        this.apiPostAuth(`api/v0/ManageGPTModel/SummarizeGPTModelChanges?id=${id}`, request, callback, error);
      },

      //GPTModelNode Management
      GetTableGPTModelNode(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetTableGPTModelNode', request, callback, error);
      },
      GetGPTModelNodeById(param, callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/GetGPTModelNodeById?id=${param}`, callback, error);
      },
      AddGPTModelNode(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/AddGPTModelNode', request, callback, error);
      },
      UpdateGPTModelNode(request, callback, error) {
        this.apiPutAuth('api/v0/ManageGPTModelNode/UpdateGPTModelNode', request, callback, error);
      },
      DeleteGPTModelNode(param, callback, error) {
        this.apiDeleteAuth('api/v0/ManageGPTModelNode/DeleteGPTModelNode?id=' + param, callback, error);
      },
      GetDDLVector(callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/GetDDLVector`, callback, error);
      },
      GetDDVectorDBNameManagement(callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/GetDDVectorDBNameManagement`, callback, error);
      },

      //Upload CSV
      GetMaxLimitedCharacter(callback, error) {
        this.apiGetAuth(`api/v0/Chat/GetMaxLimitedCharacter`, callback, error);
      },
      GetMaxLimitedCharacter_FullStream(Token, callback, error) {
        this.apiGetToken(`api/v0/Chat/GetMaxLimitedCharacterFullStream`, callback, error, Token);
      },
      // UploadCSV2Vector(request, callback, error) {
      //   let url =  `api/v0/Chat/UploadFile?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
      //   if(request.customCharacter != null){
      //     url += `&customCharacter=${request.customCharacter}`;
      //   }
      //   if (request.groupReplaceID != null) {
      //     url += `&groupReplaceID=${request.groupReplaceID}`;
      //   }
      //   if (request.EventCreate != null) {
      //     url += `&EventCreate=${request.EventCreate}`;
      //   }
      //   this.apiPostTypeFileNoResponseAuth(
      //     url,
      //     request.entity,
      //     callback,
      //     error
      //   );
      // },
      UploadCSV2Vector(formData, callback, error) {
        let url = `api/v0/Chat/UploadFile`;
        this.apiPostTypeFileNoResponseAuth(url, formData, callback, error);
      },
      UploadCSV2Vector2(request, callback, error, Token) {
        let url = `api/v0/Chat/UploadFile?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        if (request.customCharacter != null) {
          url += `&customCharacter=${request.customCharacter}`;
        }
        if (request.groupReplaceID != null) {
          url += `&groupReplaceID=${request.groupReplaceID}`;
        }
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error, Token);
      },
      SaveEditVector(request, callback, error) {
        this.apiPostAuth(`api/v0/Chat/SaveEditVector`, request, callback, error);
      },
      SaveAddVector(request, callback, error) {
        this.apiPostAuth(`api/v0/Chat/SaveAddVector`, request, callback, error);
      },
      VectorOnOff(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/VectorOnOff', request, callback, error);
      },
      UploadCSVAnswers(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/UploadCSVAnswers', request, callback, error);
      },
      GetVectorDBName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBName', request, callback, error);
      },
      GetMetaDocList(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetMetaDocList', request, callback, error);
      },
      GetMetaDocPrefixMapping(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModelNode/GetMetaDocPrefixMapping', callback, error);
      },
      GetVectorDBNameByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameByName', request, callback, error);
      },
      GetViewVectorDBNameByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetViewVectorDBNameByName', request, callback, error);
      },
      GetPrivateVectorDBNameByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetPrivateVectorDBNameByName', request, callback, error);
      },
      DeleteVectorDBNameByName(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ManageGPTModelNode/DeleteVectorDBNameByName?vectorDBName=${param}`, callback, error);
      },
      UpdatePersonalInformation(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/UpdatePersonalInformation', request, callback, error);
      },
      UpdateActiveStatus(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/UpdateActiveStatus', request, callback, error);
      },
      // MetaDoc operations
      CreateMetaDocItem(request, callback, error) {
        if (typeof FormData !== 'undefined' && request instanceof FormData) {
          this.apiPostTypeFileNoResponseAuth('api/v0/ManageGPTModelNode/CreateMetaDocItem', request, callback, error);
          return;
        }
        this.apiPostAuth('api/v0/ManageGPTModelNode/CreateMetaDocItem', request, callback, error);
      },
      CheckItemIdExists(itemId, callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/CheckItemIdExists?itemId=${encodeURIComponent(itemId)}`, callback, error);
      },
      UpdateMetaDocItem(request, callback, error) {
        if (typeof FormData !== 'undefined' && request instanceof FormData) {
          this.apiPutTypeFileNoResponseAuth('api/v0/ManageGPTModelNode/UpdateMetaDocItem', request, callback, error);
          return;
        }
        this.apiPutAuth('api/v0/ManageGPTModelNode/UpdateMetaDocItem', request, callback, error);
      },
      GetDocumentVersions(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetDocumentVersions', request, callback, error);
      },
      SaveDocumentVersion(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/SaveDocumentVersion', request, callback, error);
      },
      SaveDocumentVersionForm(formData, callback, error) {
        this.apiPostTypeFileNoResponseAuth('api/v0/ManageGPTModelNode/SaveDocumentVersion', formData, callback, error);
      },
      SearchGenerationErrorLogs(request, callback, error) {
        this.apiPostAuth('api/v0/GenerationErrorLog/search', request, callback, error);
      },
      GetGenerationErrorLog(failureGroupId, callback, error) {
        this.apiGetAuth(`api/v0/GenerationErrorLog/${encodeURIComponent(failureGroupId)}`, callback, error);
      },
      UpdateDocumentVersion(request, callback, error) {
        this.apiPutAuth('api/v0/ManageGPTModelNode/UpdateDocumentVersion', request, callback, error);
      },
      GetDocumentChunks(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetDocumentChunks', request, callback, error);
      },
      SaveEditDocumentChunk(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/SaveEditDocumentChunk', request, callback, error);
      },
      GetMetaDocInterestRates(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetMetaDocInterestRates', request, callback, error);
      },
      AddMetaDocInterestRate(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/AddMetaDocInterestRate', request, callback, error);
      },
      UpdateMetaDocInterestRate(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/UpdateMetaDocInterestRate', request, callback, error);
      },
      UpdateDocumentConfiguration(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/UpdateDocumentConfiguration', request, callback, error);
      },
      DeleteVectorDBNameById(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ManageGPTModelNode/DeleteVectorDBNameById?id=${param}`, callback, error);
      },
      ReProcessedVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReProcessed', request, callback, error);
      },
      ReFreshVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReFreshVector', request, callback, error);
      },
      ReFreshViewVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReFreshViewVector', request, callback, error);
      },
      ReFreshPrivateVector_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReFreshPrivateVectorStream', request, callback, error);
      },
      ReFreshPrivateVector_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/Chat/ReFreshPrivateVectorFullStream', request, callback, error, Token);
      },
      GetTableVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/GetTableVector', request, callback, error);
      },
      GetVectorCSVExport(param, callback, error) {
        this.apiGetAuth(`api/v0/Chat/GetVectorCSVExport?vectordbname=${param}`, callback, error);
      },
      GetVectorExcelExport(param, callback, error) {
        this.apiGetBlobAuth(`api/v0/Chat/GetVectorExcelExport?vectordbname=${param}`, callback, error);
      },
      DownloadTemplateVector_Stream(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Chat/DownloadTemplateVectorStream`, request, callback, error);
      },
      DownloadTemplateVector_FullStream(request, Token, callback, error) {
        this.apiPostTypeFileToken(`api/v0/Chat/DownloadTemplateVectorFullStream`, request, callback, error, Token);
      },
      DownloadUserManual(callback, error) {
        this.apiGetAuth(`api/v0/Chat/DownloadUserManual`, callback, error);
      },
      SaveDuplicateVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/SaveDuplicateVector', request, callback, error);
      },
      SaveReplaceVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/SaveReplaceVector', request, callback, error);
      },
      GetTableVectorVersion(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/GetTableVectorVersion', request, callback, error);
      },
      SaveReStoreVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/SaveReStoreVector', request, callback, error);
      },
      UploadCSV2Vector_Stream_Old(request, callback, error) {
        let url = `api/v0/Chat/UploadFilePrivateStream?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
        if (request.customCharacter != null) {
          url += `&customCharacter=${request.customCharacter}`;
        }
        if (request.groupReplaceID != null) {
          url += `&groupReplaceID=${request.groupReplaceID}`;
        }
        if (request.MaxLimitedCharacter != null) {
          url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        }
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      UploadCSV2Vector_Stream(request, callback, error) {
        let url = `api/v0/Chat/UploadFilePrivateStream`;
        this.apiPostTypeFileMultipart(url, request, callback, error);
      },
      UploadCSV2Vector_FullStream(request, Token, callback, error) {
        let url = `api/v0/Chat/UploadFilePrivateFullStream?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
        if (request.customCharacter != null) {
          url += `&customCharacter=${request.customCharacter}`;
        }
        if (request.groupReplaceID != null) {
          url += `&groupReplaceID=${request.groupReplaceID}`;
        }
        if (request.MaxLimitedCharacter != null) {
          url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        }
        this.apiPostTypeFileNoResponseToken(url, request.entity, callback, error, Token);
      },
      ReProcessedVector_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReProcessedPrivateStream', request, callback, error);
      },
      ReProcessedVector_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/Chat/ReProcessedPrivateFullStream', request, callback, error, Token);
      },
      GetTablePrivateVectorVersion_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTablePrivateVectorVersionStream', request, callback, error);
      },
      GetTablePrivateVectorVersion_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetTablePrivateVectorVersionFullStream', request, callback, error, Token);
      },
      SaveReStorePrivateVector_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/SaveReStorePrivateVectorStream', request, callback, error);
      },
      SaveReStorePrivateVector_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/SaveReStorePrivateVectorFullStream', request, callback, error, Token);
      },
      PrivateVectorOnOff_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/PrivateVectorOnOffStream', request, callback, error);
      },
      PrivateVectorOnOff_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/PrivateVectorOnOffFullStream', request, callback, error, Token);
      },
      PrivateVectorOnOffByFileID_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/PrivateVectorOnOffByFileIDStream', request, callback, error);
      },
      PrivateVectorOnOffByFileID_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/PrivateVectorOnOffByFileIDFullStream', request, callback, error, Token);
      },

      //DataIntegration
      GetDDdataintegration(callback, error) {
        this.apiGetAuth(`api/v0/DataIntegration/GetDDdataintegration`, callback, error);
      },
      GetTableDataIntegration(request, callback, error) {
        const payload = {
          page: 1,
          perPage: 10,
          DataName: null,
          CreateBy: null,
          ActiveStatus: null,
          EffectiveStartDateFrom: null,
          EffectiveStartDateTo: null,
          EffectiveEndDateFrom: null,
          EffectiveEndDateTo: null,
          sortDesc: null,
          sortBy: null,
          ...request,
        };
        this.apiPostAuth(`api/v0/DataIntegration/GetTableDataIntegration`, payload, callback, error);
      },
      GetDataIntegrationDetail(id, callback, error) {
        this.apiGetAuth(`api/v0/DataIntegration/GetDataIntegrationDetail?id=${id}`, callback, error);
      },
      AddDataIntegration_Table(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/AddDataIntegration_Table`, request.ReqData, callback, error);
      },
      AddDataIntegration_Data(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/DataIntegration/AddDataIntegration_Data?id=${request.id}&deleteAll=${request.deleteAll}`, request.uploaded_file, callback, error);
      },
      UpdateDataIntegration(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/UpdateDataIntegration`, request, callback, error);
      },
      DeleteDataIntegration(id, callback, error) {
        this.apiDeleteAuth(`api/v0/DataIntegration/DeleteDataIntegration?id=${id}`, callback, error);
      },
      GetDDLDataIntegration(callback, error) {
        this.apiGetAuth(`api/v0/DataIntegration/GetDDLDataIntegration`, callback, error);
      },
      TestConnection(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/TestConnection`, request, callback, error);
      },
      ValidateExternalColumn(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/ValidateExternalColumn`, request, callback, error);
      },
      AddDataIntegrationConnection(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/AddDataIntegrationConnection`, request, callback, error);
      },
      GetTableDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/GetTableDataIntegrationDetail`, request, callback, error);
      },
      AddDataDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/AddDataDataIntegrationDetail`, request, callback, error);
      },
      UpdateDataDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/UpdateDataDataIntegrationDetail`, request, callback, error);
      },
      DeleteDataDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/DeleteDataDataIntegrationDetail`, request, callback, error);
      },
      UpdateDataIntegrationActiveStatus(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/UpdateActiveStatus`, request, callback, error);
      },

      // Mutual Fund integration (standalone from Database Integration)
      GetTableMutualFundIntegration(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/GetTableMutualFundIntegration', request, callback, error);
      },
      // The view layer: which views the fund node reads, the SQL they are running, and how each
      // import table is joined into them. Read-only until the operator saves the relations.
      GetMutualFundViewLayer(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetViewLayer', callback, error);
      },
      SaveMutualFundViewRelations(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveViewRelations', request, callback, error);
      },
      RefreshMutualFundViewLayer(callback, error) {
        this.apiPostAuth('api/v0/MutualFund/RefreshViewLayer', {}, callback, error);
      },
      GetMutualFundIntegrationDetail(id, callback, error) {
        this.apiGetAuth(`api/v0/MutualFund/GetMutualFundIntegrationDetail?id=${id}`, callback, error);
      },
      AddMutualFundIntegration_Table(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/AddMutualFundIntegration_Table', request.ReqData, callback, error);
      },
      AddMutualFundIntegration_Data(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/MutualFund/AddMutualFundIntegration_Data?id=${request.id}&deleteAll=${request.deleteAll}`, request.uploaded_file, callback, error);
      },
      UpdateMutualFundIntegration(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/UpdateMutualFundIntegration', request, callback, error);
      },
      DeleteMutualFundIntegration(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MutualFund/DeleteMutualFundIntegration?id=${id}`, callback, error);
      },
      TestMutualFundIntegrationConnection(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/TestConnection', request, callback, error);
      },
      ValidateMutualFundIntegrationExternalColumn(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/ValidateExternalColumn', request, callback, error);
      },
      AddMutualFundIntegrationConnection(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/AddMutualFundIntegrationConnection', request, callback, error);
      },
      GetTableMutualFundIntegrationDetail(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/GetTableMutualFundIntegrationDetail', request, callback, error);
      },
      AddDataMutualFundIntegrationDetail(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/AddDataMutualFundIntegrationDetail', request, callback, error);
      },
      UpdateDataMutualFundIntegrationDetail(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/UpdateDataMutualFundIntegrationDetail', request, callback, error);
      },
      DeleteDataMutualFundIntegrationDetail(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/DeleteDataMutualFundIntegrationDetail', request, callback, error);
      },
      UpdateMutualFundIntegrationActiveStatus(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/UpdateActiveStatus', request, callback, error);
      },
      InitializeMutualFundImportFramework(callback, error) {
        this.apiPostAuth('api/v0/MutualFund/InitializeImportFramework', {}, callback, error);
      },
      GetMutualFundImportFrameworkStatus(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetImportFrameworkStatus', callback, error);
      },
      GetMutualFundImportBatchHistory(take, callback, error) {
        this.apiGetAuth(`api/v0/MutualFund/GetImportBatchHistory?take=${take || 10}`, callback, error);
      },
      TestImportMutualFundCustomerWorkbook(formData, callback, error) {
        this.apiPostTypeFileNoResponseAuth('api/v0/MutualFund/TestImportCustomerWorkbook', formData, callback, error);
      },
      ImportMutualFundJson(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/ImportJson', request, callback, error);
      },
      TestImportMutualFundMorningStarPackage(formData, callback, error) {
        this.apiPostTypeFileNoResponseAuth('api/v0/MutualFund/TestImportMorningStarPackage', formData, callback, error);
      },
      ImportMutualFundMorningStarFolder(formData, callback, error) {
        this.apiPostTypeFileNoResponseAuth('api/v0/MutualFund/ImportMorningStarFolder', formData, callback, error);
      },
      GetMutualFundApiEndpoints(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetApiEndpoints', callback, error);
      },
      TestNewsApiConnection(request, callback, error) {
        // Do not log Axios errors: their request config contains the client secret.
        return axios.post(this.urlApi + 'api/v0/NewsApi/TestConnection', request, {
          withCredentials: true,
          timeout: 70000,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        }).then(response => callback(response.data)).catch(error);
      },
      NewsApiRequest(action, request = {}) {
        return axios.post(this.urlApi + 'api/v0/NewsApi/' + action, request, {
          withCredentials: true, timeout: 90000,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        }).then(response => response.data);
      },
      SaveMutualFundApiEndpoint(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveApiEndpoint', request, callback, error);
      },
      DeleteMutualFundApiEndpoint(endpointId, callback, error) {
        this.apiDeleteAuth(`api/v0/MutualFund/DeleteApiEndpoint?endpointId=${endpointId}`, callback, error);
      },
      TestMutualFundApiEndpoint(endpointId, callback, error) {
        this.apiPostAuth(`api/v0/MutualFund/TestApiEndpoint?endpointId=${endpointId}`, {}, callback, error);
      },
      PreviewMutualFundApiEndpoint(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/PreviewApiEndpoint', request, callback, error);
      },
      RunMutualFundApiSync(endpointId, callback, error) {
        const query = endpointId ? `?endpointId=${endpointId}` : '';
        this.apiPostAuth(`api/v0/MutualFund/RunApiSync${query}`, {}, callback, error);
      },
      GetMutualFundApiSyncRunHistory(take, callback, error) {
        this.apiGetAuth(`api/v0/MutualFund/GetApiSyncRunHistory?take=${take || 25}`, callback, error);
      },
      GetMutualFundSyncSchedules(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetSyncSchedules', callback, error);
      },
      SaveMutualFundSyncSchedule(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveSyncSchedule', request, callback, error);
      },
      GetMutualFundFileFeedConnections(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetFileFeedConnections', callback, error);
      },
      GetMutualFundImportProblems(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetImportProblems?take=25', callback, error);
      },
      GetMutualFundImportNotificationSettings(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetImportNotificationSettings', callback, error);
      },
      SaveMutualFundImportNotificationSettings(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveImportNotificationSettings', request, callback, error);
      },
      SendMutualFundImportProblemEmail(importBatchId, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SendImportProblemEmail', { importBatchId }, callback, error);
      },
      GetMutualFundManagedFileTableMappings(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetManagedFileTableMappings', callback, error);
      },
      SaveMutualFundManagedFileTableMapping(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveManagedFileTableMapping', request, callback, error);
      },
      SaveMutualFundFileFeedConnection(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveFileFeedConnection', request, callback, error);
      },
      TestMutualFundFileFeedConnection(connectionId, callback, error) {
        this.apiPostAuth(`api/v0/MutualFund/TestFileFeedConnection?fileFeedConnectionId=${connectionId}`, {}, callback, error);
      },
      GetMutualFundFileFeedDownloadUrl(connectionId, selectedDate) {
        if (!selectedDate) return '';
        return this.urlApi + `api/v0/MutualFund/DownloadFileFeedZip?fileFeedConnectionId=${encodeURIComponent(connectionId)}&selectedDate=${encodeURIComponent(selectedDate)}`;
      },
      TestMutualFundFileFeedConfiguration(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/TestFileFeedConfiguration', request, callback, error);
      },
      RunMutualFundFileFeedConnection(connectionId, selectedDate, callback, error) {
        this.apiPostAuth(`api/v0/MutualFund/RunFileFeedConnection?fileFeedConnectionId=${connectionId}&selectedDate=${encodeURIComponent(selectedDate)}`, {}, callback, error);
      },
      GetMutualFundFileFeedRun(connectionId, runId, callback, error) {
        this.apiGetAuth(`api/v0/MutualFund/GetFileFeedRun?fileFeedConnectionId=${connectionId}${runId ? `&runId=${runId}` : ''}`, callback, error);
      },
      GetMutualFundFileFeedRunHistory(connectionId, callback, error) {
        this.apiGetAuth(`api/v0/MutualFund/GetFileFeedRunHistory?fileFeedConnectionId=${connectionId}`, callback, error);
      },
      // Tax card configs: the whole library round-trips in one GET and one POST, because SAVE replaces
      // the list wholesale. `request` is { items: [{ configCode, configName, configJson, sortOrder,
      // isActive }] } — no cardType and no id: the server derives the first from the JSON and renumbers
      // the rest from the order the items arrive in.
      GetMutualFundCardConfigs(callback, error) {
        this.apiGetAuth('api/v0/MutualFund/GetCardConfigs', callback, error);
      },
      SaveMutualFundCardConfigs(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/SaveCardConfigs', request, callback, error);
      },
      // Live card preview. `request` is { configJson, fundCodes: [], lookupType, lang }; configJson is the
      // template TEXT exactly as typed. The reply is always 200 — Data is { raw, errors: [], cardType,
      // usedLang } and `raw` is the rendered envelope as a STRING, so hand it straight to the preview
      // component and never JSON.stringify it again. A card exists when raw is non-null, NOT when errors
      // is empty: some entries are warnings that still ship a card.
      PreviewMutualFundCardConfig(request, callback, error) {
        this.apiPostAuth('api/v0/MutualFund/PreviewCardConfig', request, callback, error);
      },
      // Fund picker for that preview. `request` is { q, limit }; the reply Data is
      // [{ fundCode, mStarId, name }] capped at 50. A blank q lists the first funds.
      SearchMutualFundFunds(request, callback, error) {
        const params = request || {};
        const keyword = encodeURIComponent(params.q == null ? '' : params.q);
        const limit = Number(params.limit) > 0 ? Number(params.limit) : 20;
        this.apiGetAuth(`api/v0/MutualFund/SearchFunds?q=${keyword}&limit=${limit}`, callback, error);
      },

      //Interest Rate Management
      GetInterestRateCategories(callback, error) {
        this.apiGetAuth('api/v1/InterestRate/GetMasterDataLoadInterestAsync', callback, error);
      },
      AddInterestRateCategory(request, callback, error) {
        this.apiPostAuth('api/v1/InterestRate/categories', request, callback, error);
      },
      UpdateInterestRateCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/InterestRate/categories/${id}`, request, callback, error);
      },
      DeleteInterestRateCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/InterestRate/categories/${id}`, callback, error);
      },
      GetInterestRates(callback, error) {
        this.apiGetAuth('api/v1/InterestRate/interest-rates', callback, error);
      },
      GetInterestRateById(id, callback, error) {
        this.apiGetAuth(`api/v1/InterestRate/interest-rates/${id}`, callback, error);
      },
      AddInterestRate(request, callback, error) {
        this.apiPostAuth('api/v1/InterestRate/interest-rates', request, callback, error);
      },
      UpdateInterestRate(id, request, callback, error) {
        this.apiPutAuth(`api/v1/InterestRate/interest-rates/${id}`, request, callback, error);
      },
      DeleteInterestRate(id, callback, error) {
        this.apiDeleteAuth(`api/v1/InterestRate/interest-rates/${id}`, callback, error);
      },
      CalculateInterestRatePreview(request, callback, error) {
        this.apiPostAuth('api/v1/InterestRate/calculate-preview', request, callback, error);
      },

      //Intent
      GetTableIntentGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/GetTableIntentGroup`, request, callback, error);
      },
      GetTableIntentSession(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/GetTableIntentSession`, request, callback, error);
      },
      GetIntentSessionDetailById(id, callback, error) {
        this.apiGetAuth(`api/v0/Intent/GetIntentSessionDetailById?Id=${id}`, callback, error);
      },
      DDIntentSession(callback, error) {
        this.apiGetAuth(`api/v0/Intent/DDIntentSession`, callback, error);
      },
      DDIntentGroup(callback, error) {
        this.apiGetAuth(`api/v0/Intent/DDIntentGroup`, callback, error);
      },
      CreateIntentGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/CreateIntentGroup`, request, callback, error);
      },
      UpdateIntentGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/UpdateIntentGroup`, request, callback, error);
      },
      DeleteIntentGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/DeleteIntentGroup`, request, callback, error);
      },
      CreateIntentSession(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/CreateIntentSession`, request, callback, error);
      },
      UpdateIntentSession(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/UpdateIntentSession`, request, callback, error);
      },
      DeleteIntentSession(request, callback, error) {
        this.apiPostAuth(`api/v0/Intent/DeleteIntentSession`, request, callback, error);
      },

      //ModelAndVectorManagement
      GetVectorDBNameMappinghGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameMappinghGPTModel', request, callback, error);
      },
      GetVectorDBNameMappinghGPTModelByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameMappinghGPTModelByName', request, callback, error);
      },
      GetVectorDBNameMappinghGPTModelById(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameMappinghGPTModelById', request, callback, error);
      },
      GetDDVectorDBName(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModelNode/GetDDVectorDBName', callback, error);
      },
      UpdateVectorDBNameMappinghGPTModel(request, callback, error) {
        this.apiPutAuth(`api/v0/ManageGPTModelNode/UpdateVectorDBNameMappinghGPTModel`, request, callback, error);
      },
      DeleteVectorDBNameMappinghGPTModel(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ManageGPTModelNode/DeleteVectorDBNameMappinghGPTModel?vectorDBName=${param}`, callback, error);
      },

      //Userprofile
      GetUserById(callback, error) {
        this.apiGetAuth(`api/v0/User/GetUserById`, callback, error);
      },

      //LogMessage
      GetLogReferenceFromLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetLogReference', request, callback, error);
      },
      GetLogMonitorFromLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetLogMonitor', request, callback, error);
      },
      GetLogDocumentReferenceFromLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetLogDocumentReference', request, callback, error);
      },
      GetTableLogMessage(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetTableLogMessage', request, callback, error);
      },
      GetTableContactAdminChatLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetTableContactAdminChatLog', request, callback, error);
      },
      GetExportCSVLogMessage(request, callback, error) {
        this.apiPostAuth('api/v0/Log/ExportCSVLogMessage', request, callback, error);
      },
      GetExportLogMonitoring(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportLogMonitoring`, request, callback, error);
      },
      GetExportLog(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportLog`, request, callback, error);
      },
      GetExportLogExtra(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportLogExtra`, request, callback, error);
      },
      ExportFileQuestionSet(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportFileQuestionSet`, request, callback, error);
      },
      ExportQuestionSet(request, callback, error) {
        this.apiPostAuth(`api/v0/Log/ExportQuestionSet`, request, callback, error);
      },
      // Tax Chat Log — ฝาแฝดฝั่งภาษีของชุด Chat Log ด้านบน (API คืน userChannel/createBy เป็น ciphertext อยู่แล้ว)
      GetTableTaxChatLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetTableTaxChatLog', request, callback, error);
      },
      GetExportTaxChatLog(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportTaxChatLog`, request, callback, error);
      },
      GetExportTaxChatLogExtra(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportTaxChatLogExtra`, request, callback, error);
      },
      ExportFileTaxQuestionSet(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportFileTaxQuestionSet`, request, callback, error);
      },
      ExportTaxQuestionSet(request, callback, error) {
        this.apiPostAuth(`api/v0/Log/ExportTaxQuestionSet`, request, callback, error);
      },
      GetEventLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/EventLogShow', request, callback, error);
      },
      GetApiExternal(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetApiExternal', request, callback, error);
      },
      GetApiExternalById(id, callback, error) {
        this.apiGetAuth(`api/v0/Log/GetApiExternalById?id=${id}`, callback, error);
      },
      // L6 — หน้า log MIAW/webhook · Super admin เท่านั้น (APIAuthen listRole ["0"])
      GetSocialApiLogConfig(callback, error) {
        this.apiGetAuth('api/v1/SocialApiLog/config', callback, error);
      },
      SearchSocialApiLog(request, callback, error) {
        this.apiPostAuth('api/v1/SocialApiLog/search', request, callback, error);
      },
      GetSocialApiLogById(id, callback, error) {
        this.apiGetAuth(`api/v1/SocialApiLog/${id}`, callback, error);
      },
      GetSocialApiLogTimeline(correlationId, callback, error) {
        this.apiGetAuth(`api/v1/SocialApiLog/correlation/${encodeURIComponent(correlationId)}`, callback, error);
      },

      ExportApiExternal(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/Log/ExportApiExternal', request, callback, error);
      },

      //Dashboard
      GetDashboardOverview(request, callback, error) {
        this.apiPostAuth('api/v0/Dashboard/Overview', request, callback, error);
      },
      GetDashboardLHB(request, callback, error) {
        this.apiPostAuth('api/v1/DashboardLHB', request, callback, error);
      },
      GetExportProactivePerformanceDetails(request, callback, error) {
        this.apiPostAuth('api/v1/DashboardLHB/GetExportProactivePerformanceDetails', request, callback, error);
      },
      GetExportUsageUsers(callback, error) {
        this.apiGetAuth('api/v1/DashboardLHB/GetExportUsageUsers', callback, error);
      },

      //ChatServices
      // GetTopicAll(callback, error){
      //   this.apiGetAuth('api/v0/ChatHub/GetTopicAll', callback, error);
      // },
      GetTopicAll(request, callback, error) {
        this.apiPostAuth('api/v0/ChatHub/GetTopicAll', request, callback, error);
      },
      GetTopicMyLockAll(request, callback, error) {
        this.apiPostAuth('api/v0/ChatHub/GetTopicMyLockAll', request, callback, error);
      },
      GetTopicClosedAll(request, callback, error) {
        this.apiPostAuth('api/v0/ChatHub/GetTopicClosedAll', request, callback, error);
      },
      GetHistoryMessage(request, Config, callback, error) {
        this.apiPostAuthNoAlert_Config(`api/v0/ChatHub/GetHistoryMessage`, request, Config, callback, error);
      },
      AdminReplyStatus(id, status, connectionId, callback, error) {
        this.apiGetAuth(`api/v0/ChatHub/AdminReplyStatus?id=${id}&status=${status}&connectionId=${connectionId}`, callback, error);
      },
      LatestMessage(request, callback, error) {
        this.apiPostAuth('api/v0/ChatHub/LatestMessage', request, callback, error);
      },
      MarkAsRead(request, callback, error) {
        this.apiPostAuth('api/v0/Chathub/MarkAsRead', request, callback, error);
      },
      GetTopicUnread(callback, error) {
        this.apiGetAuth('api/v0/ChatHub/GetTopicUnread', callback, error);
      },
      //Setup
      // GetSetupOverview(request, callback, error) {
      //     const name = request.name;
      //     const index = request.index;
      //     const size = request.size;
      //     this.apiGetAuth(`api/v0/Setup/Overview?name=${name}&index=${index}&size=${size}`, callback, error);
      // },
      GetSetupOverview(callback, error) {
        this.apiGetAuth(`api/v0/Setup/Overview`, callback, error);
      },
      GetSetupOverviewGeneral(callback, error) {
        this.apiGetAuth(`api/v0/Setup/OverviewGeneral`, callback, error);
      },
      GetOverviewSocial(callback, error) {
        this.apiGetAuth(`api/v0/Setup/OverviewSocial`, callback, error);
      },
      GetTableGroupModel(callback, error) {
        this.apiPostAuth(`api/v0/Setup/GetTableGroupModel`, callback, error);
      },
      GetDDGroupModel(callback, error) {
        this.apiGetAuth(`api/v0/Setup/GetDDGroupModel`, callback, error);
      },
      GetSetupCreate(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/Create', request, callback, error);
      },
      CreateGroupModel(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/CreateGroupModel', request, callback, error);
      },
      GetSetupUpdate(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/Update', request, callback, error);
      },
      GetSetupUpdateGeneral(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateGeneral', request, callback, error);
      },

      //Voice Configuration (LH Bank Configuration -> Voice Configs)
      //ป้อนค่าให้ api/v2|v3/LHB/GetSTTConfigurationLHB และ api/v3|v4/LHB/GetTTSConfigurationLHB
      GetTableVoiceConfiguration(request, callback, error) {
        this.apiPostAuth('api/v1/VoiceConfiguration/GetTableVoiceConfiguration', request, callback, error);
      },
      GetVoiceConfigurationById(id, callback, error) {
        this.apiGetAuth(`api/v1/VoiceConfiguration/GetVoiceConfigurationById?id=${id}`, callback, error);
      },
      CreateVoiceConfiguration(request, callback, error) {
        this.apiPostAuth('api/v1/VoiceConfiguration/CreateVoiceConfiguration', request, callback, error);
      },
      UpdateVoiceConfiguration(request, callback, error) {
        this.apiPutAuth('api/v1/VoiceConfiguration/UpdateVoiceConfiguration', request, callback, error);
      },
      GetDDVoiceConfiguration(callback, error) {
        this.apiGetAuth('api/v1/VoiceConfiguration/GetDDVoiceConfiguration', callback, error);
      },
      DeleteVoiceConfiguration(id, callback, error) {
        this.apiDeleteAuth(`api/v1/VoiceConfiguration/DeleteVoiceConfiguration?id=${id}`, callback, error);
      },
      UpdateSocial(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateSocial', request, callback, error);
      },
      // TikTok OAuth · PRD-tiktok-channel.md ข้อ 7.1
      // ⚠️ ทุก path ที่เพิ่มตรงนี้ต้องมีแถวใน WebAPI/Authen/APIAuthen.cs ด้วย ไม่งั้นได้ 401 แล้วเด้ง logout
      GetTikTokStatus(callback, error) {
        this.apiGetAuth('api/v1/TikTokOAuth/Status', callback, error);
      },
      GetTikTokAuthorizeUrl(socialId, callback, error) {
        this.apiGetAuth(`api/v1/TikTokOAuth/AuthorizeUrl/${socialId}`, callback, error);
      },
      ConnectTikTok(request, callback, error) {
        this.apiPostAuth('api/v1/TikTokOAuth/Connect', request, callback, error);
      },
      DisconnectTikTok(socialId, callback, error) {
        this.apiPostAuth(`api/v1/TikTokOAuth/Disconnect/${socialId}`, {}, callback, error);
      },
      UpdateGroupModel(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateGroupModel', request, callback, error);
      },
      GetSetupDelete(id, callback, error) {
        this.apiDeleteAuth(`api/v0/Setup/Delete?id=${id}`, callback, error);
      },
      DeleteGroupModel(id, callback, error) {
        this.apiDeleteAuth(`api/v0/Setup/DeleteGroupModel?id=${id}`, callback, error);
      },
      GetSetupApply(callback, error) {
        this.apiPostAuth(`api/v0/Setup/Apply`, callback, error);
      },
      GetSummaryAgent(callback, error) {
        this.apiGetAuth(`api/v0/Setup/GetSummaryAgent`, callback, error);
      },
      CreateSummaryAgent(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/Create', request, callback, error);
      },
      UpdateSummaryAgents(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateSummaryAgents', request, callback, error);
      },

      //ModelQuick
      GetTableModelQuickGroup(callback, error) {
        this.apiPostAuth(`api/v0/ModelQuick/GetTableModelQuickGroup`, callback, error);
      },
      CreateModelQuickGroup(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/CreateModelQuickGroup', request, callback, error);
      },
      UpdateModelQuickGroup(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/UpdateModelQuickGroup', request, callback, error);
      },
      DeleteModelQuickGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ModelQuick/DeleteModelQuickGroup?id=${id}`, callback, error);
      },
      GetDDModelQuickGroup(callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetDDModelQuickGroup`, callback, error);
      },
      GetDDModelQuick(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/GetDDModelQuick', request, callback, error);
      },

      //Quick reply
      GetDDQuickReplyGroup(callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetDDQuickReplyGroup`, callback, error);
      },
      GetDDModelQuickReply(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/GetDDModelQuickReply', request, callback, error);
      },
      GetQuickReplyGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelQuick/GetQuickReplyGroup`, request, callback, error);
      },
      CreateQuickReplyGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelQuick/CreateQuickReplyGroup`, request, callback, error);
      },
      DeleteQuickReplyGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ModelQuick/DeleteQuickReplyGroup?id=${id}`, callback, error);
      },
      UpdateModelQuickReply(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/UpdateModelQuickReply', request, callback, error);
      },
      GetModelQuickGroup(callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetModelQuickGroup`, callback, error);
      },
      GetModelGroupAndQuickReply(id, callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetModelGroupAndQuickReply?id=${id}`, callback, error);
      },
      GetModelQuickCommand(id, callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetModelQuickCommand?id=${id}`, callback, error);
      },
      UploadImageModelQuick(request, callback, error) {
        let url = `api/v0/ModelQuick/UploadFileImageModelQuick`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },

      //Replace text
      GetTableGroupReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/GetTableGroupReplaceText`, callback, error);
      },
      GetTableReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/GetTableReplaceText`, callback, error);
      },
      CreateGroupReplace(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/CreateGroupReplace`, callback, error);
      },
      CreateReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/CreateReplaceText`, callback, error);
      },
      UpdateReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/UpdateReplaceText`, callback, error);
      },
      DeleteGroupReplaceText(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ReplaceText/DeleteGroupReplaceText?id=${id}`, callback, error);
      },

      DeleteReplaceText(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ReplaceText/DeleteReplaceText?id=${id}`, callback, error);
      },
      GetDDGroupReplaceDB(callback, error) {
        this.apiGetAuth('api/v0/ReplaceText/GetDDGroupReplaceDB', callback, error);
      },
      GetDDGroupReplaceDBForVector(vectordbName, callback, error) {
        this.apiGetAuth(`api/v0/ReplaceText/GetDDGroupReplaceDBForVector?vectordbName=${vectordbName}`, callback, error);
      },
      UploadFileReplaceText(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(
          `api/v0/ReplaceText/UploadFileReplaceText?groupName=${request.groupName}&deleteAll=${request.DeleteAll}&groupReplaceID=${request.groupReplaceID}`,
          request.uploaded_file,
          callback,
          error
        );
      },

      //Flow Management
      GetTableFlowManagement(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/GetTableFlowManagement', request, callback, error);
      },
      GetFlowById(id, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowById?id=${id}`, callback, error);
      },
      GetFlowVersionById(id, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowVersionById?id=${id}`, callback, error);
      },
      GetFlowByGroupFlowId(groupFlowId, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowByGroupFlowId?groupFlowId=${groupFlowId}`, callback, error);
      },
      GetFlowVersions(groupFlowId, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowVersions?groupFlowId=${groupFlowId}`, callback, error);
      },
      CreateFlow(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/CreateFlow', request, callback, error);
      },
      UpdateFlow(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/UpdateFlow', request, callback, error);
      },
      RestoreFlowVersion(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/RestoreFlowVersion', request, callback, error);
      },
      DeleteFlow(id, callback, error) {
        this.apiPostAuth('api/v0/Flow/DeleteFlow', id, callback, error);
      },
      GetFlowDropdown(callback, error) {
        this.apiGetAuth('api/v0/Flow/GetFlowDropdown', callback, error);
      },
      SummarizeFlowChanges(request, id, callback, error) {
        this.apiPostAuth(`api/v0/Flow/SummarizeFlowChanges?id=${id}`, request, callback, error);
      },

      // Flow Debug API (SSE-based, uses fetch instead of axios)
      DebugFlowSSE(request) {
        // Returns a fetch Response with readable stream for SSE
        return fetch(this.urlApi + 'api/v0/FlowEngine/DebugFlow', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/event-stream',
          },
          credentials: 'include',
          body: JSON.stringify(request),
        });
      },
      DebugResume(sessionId, request, callback, error) {
        this.apiPostAuth(`api/v0/FlowEngine/DebugResume/${sessionId}`, request || {}, callback, error);
      },
      DebugStop(sessionId, callback, error) {
        this.apiPostAuth(`api/v0/FlowEngine/DebugStop/${sessionId}`, {}, callback, error);
      },

      // Document Group Management
      GetTableDocumentGroup(request, callback, error) {
        this.apiPostAuth('api/v0/DocumentGroup/GetTableDocumentGroup', request, callback, error);
      },
      GetDocumentGroupById(id, callback, error) {
        this.apiGetAuth(`api/v0/DocumentGroup/GetDocumentGroupById?id=${id}`, callback, error);
      },
      GetDDDocumentGroup(callback, error) {
        this.apiGetAuth('api/v0/DocumentGroup/GetDDDocumentGroup', callback, error);
      },
      CreateDocumentGroup(request, callback, error) {
        this.apiPostAuth('api/v0/DocumentGroup/CreateDocumentGroup', request, callback, error);
      },
      UpdateDocumentGroup(request, callback, error) {
        this.apiPutAuth('api/v0/DocumentGroup/UpdateDocumentGroup', request, callback, error);
      },
      DeleteDocumentGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/DocumentGroup/DeleteDocumentGroup?id=${id}`, callback, error);
      },
      GetDocumentsByGroupId(groupId, callback, error) {
        this.apiGetAuth(`api/v0/DocumentGroup/GetDocumentsByGroupId?groupId=${groupId}`, callback, error);
      },

      // Community Detection Management
      GetTableCommunity(request, callback, error) {
        this.apiPostAuth('api/v0/Community/GetTableCommunity', request, callback, error);
      },
      GetCommunityById(id, callback, error) {
        this.apiGetAuth(`api/v0/Community/GetCommunityById?id=${id}`, callback, error);
      },
      CreateCommunity(request, callback, error) {
        this.apiPostAuth('api/v0/Community/CreateCommunity', request, callback, error);
      },
      UpdateCommunity(request, callback, error) {
        this.apiPutAuth('api/v0/Community/UpdateCommunity', request, callback, error);
      },
      DeleteCommunity(id, callback, error) {
        this.apiDeleteAuth(`api/v0/Community/DeleteCommunity?id=${id}`, callback, error);
      },
      ProcessCommunity(id, callback, error) {
        this.apiPostAuth(`api/v0/Community/ProcessCommunity?id=${id}`, {}, callback, error);
      },
      GetCommunityGraph(id, callback, error) {
        this.apiGetAuth(`api/v0/Community/GetCommunityGraph?id=${id}`, callback, error);
      },
      GetCommunityGroups(id, callback, error) {
        this.apiGetAuth(`api/v0/Community/GetCommunityGroups?id=${id}`, callback, error);
      },
      GetAvailableDocuments(callback, error) {
        this.apiGetAuth('api/v0/Community/GetAvailableDocuments', callback, error);
      },
      GetDefaultPrompt(callback, error) {
        this.apiGetAuth('api/v0/Community/GetDefaultPrompt', callback, error);
      },
      GetCommunityDropdown(callback, error) {
        this.apiGetAuth('api/v0/Community/GetCommunityDropdown', callback, error);
      },
      GetChunksByEntityId(communityId, entityId, callback, error) {
        this.apiGetAuth(`api/v0/Community/GetChunksByEntityId?communityId=${communityId}&entityId=${encodeURIComponent(entityId)}`, callback, error);
      },

      // Meta Community Detection Management
      GetTableMetaCommunity(request, callback, error) {
        this.apiPostAuth('api/v0/MetaCommunity/GetTableMetaCommunity', request, callback, error);
      },
      GetMetaCommunityById(id, callback, error) {
        this.apiGetAuth(`api/v0/MetaCommunity/GetMetaCommunityById?id=${id}`, callback, error);
      },
      CreateMetaCommunity(request, callback, error) {
        this.apiPostAuth('api/v0/MetaCommunity/CreateMetaCommunity', request, callback, error);
      },
      UpdateMetaCommunity(request, callback, error) {
        this.apiPutAuth('api/v0/MetaCommunity/UpdateMetaCommunity', request, callback, error);
      },
      DeleteMetaCommunity(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MetaCommunity/DeleteMetaCommunity?id=${id}`, callback, error);
      },
      ProcessMetaCommunity(id, callback, error) {
        this.apiPostAuth(`api/v0/MetaCommunity/ProcessMetaCommunity?id=${id}`, {}, callback, error);
      },
      GetMetaCommunityGraph(id, callback, error) {
        this.apiGetAuth(`api/v0/MetaCommunity/GetMetaCommunityGraph?id=${id}`, callback, error);
      },
      GetMetaCommunityGroups(id, callback, error) {
        this.apiGetAuth(`api/v0/MetaCommunity/GetMetaCommunityGroups?id=${id}`, callback, error);
      },
      GetMetaAvailableDocuments(callback, error, category = null, type = null) {
        let url = 'api/v0/MetaCommunity/GetAvailableMetaDocuments';
        const params = [];
        if (category) params.push(`category=${encodeURIComponent(category)}`);
        if (type) params.push(`type=${encodeURIComponent(type)}`);
        if (params.length > 0) url += '?' + params.join('&');
        this.apiGetAuth(url, callback, error);
      },
      GetMetaDistinctCategories(callback, error) {
        this.apiGetAuth('api/v0/MetaCommunity/GetDistinctCategories', callback, error);
      },
      GetMetaTypesByCategory(category, callback, error) {
        this.apiGetAuth(`api/v0/MetaCommunity/GetTypesByCategory?category=${encodeURIComponent(category)}`, callback, error);
      },
      GetMetaDefaultPrompt(callback, error) {
        this.apiGetAuth('api/v0/MetaCommunity/GetDefaultPrompt', callback, error);
      },
      GetMetaCommunityDropdown(callback, error) {
        this.apiGetAuth('api/v0/MetaCommunity/GetMetaCommunityDropdown', callback, error);
      },
      GetMetaChunksByEntityId(metaCommunityId, entityId, callback, error) {
        this.apiGetAuth(`api/v0/MetaCommunity/GetChunksByEntityId?metaCommunityId=${metaCommunityId}&entityId=${encodeURIComponent(entityId)}`, callback, error);
      },
      CheckMetaDocumentChanges(metaCommunityId, callback, error) {
        this.apiGetAuth(`api/v0/MetaCommunity/CheckDocumentChanges?metaCommunityId=${metaCommunityId}`, callback, error);
      },
      // Product Group Collection Management
      GetTableProductGroupCollection(request, callback, error) {
        this.apiPostAuth('api/v0/ProductGroupCollection/GetTableProductGroupCollection', request, callback, error);
      },
      GetProductGroupCollectionById(id, callback, error) {
        this.apiGetAuth(`api/v0/ProductGroupCollection/GetProductGroupCollectionById?id=${id}`, callback, error);
      },
      GetDDProductGroupCollection(callback, error) {
        this.apiGetAuth('api/v0/ProductGroupCollection/GetDDProductGroupCollection', callback, error);
      },
      CreateProductGroupCollection(request, callback, error) {
        this.apiPostAuth('api/v0/ProductGroupCollection/CreateProductGroupCollection', request, callback, error);
      },
      UpdateProductGroupCollection(request, callback, error) {
        this.apiPutAuth('api/v0/ProductGroupCollection/UpdateProductGroupCollection', request, callback, error);
      },
      DeleteProductGroupCollection(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ProductGroupCollection/DeleteProductGroupCollection?id=${id}`, callback, error);
      },
      GetProductGroupsByCollectionId(collectionId, callback, error) {
        this.apiGetAuth(`api/v0/ProductGroupCollection/GetProductGroupsByCollectionId?collectionId=${collectionId}`, callback, error);
      },

      //Validation Generate
      GetTableValidationGenerate(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationGenerate/GetTableValidationGenerate`, request, callback, error);
      },
      CreateValidationGenerate(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationGenerate/CreateValidationGenerate`, request, callback, error);
      },
      UploadValidationGenerate(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationGenerate/UploadValidationGenerate?id=${request.id}`, request.entity, callback, error);
      },
      DownloadCSVQuestions(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/DownloadCSVQuestions?id=${param}`, callback, error);
      },
      ReprocessValidationGenerate(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/ReprocessValidationGenerate?id=${param}`, callback, error);
      },
      GetValidationGenerateDD(callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/GetValidationGenerateDD`, callback, error);
      },
      GetValidationGenerateDetail(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/GetValidationGenerateDetail?GenerateID=${param}`, callback, error);
      },
      EditValidationGenerate(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationGenerate/EditValidationGenerate`, request, callback, error);
      },
      DeleteValidationGenerate(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/DeleteValidationGenerate?GenerateID=${param}`, callback, error);
      },

      //Validation Process
      GetTableValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetTableValidationProcess`, request, callback, error);
      },
      CreateValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/CreateValidationProcess`, request, callback, error);
      },
      EditValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/EditValidationProcess`, request, callback, error);
      },
      UploadValidationProcess(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationProcess/UploadValidationProcess?id=${request.id}&GroupQuestion=${request.GroupQuestion}`, request.entity, callback, error);
      },
      DownloadCSVAnswer(request, callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/DownloadCSVAnswer?id=${request.id}&IsGroup=${request.isGroup}`, callback, error);
      },
      ReprocessValidationProcess(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/ReprocessValidationProcess?id=${param}`, callback, error);
      },
      SetReprocessValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/SetReprocessValidationProcess`, request, callback, error);
      },
      GenerateValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GenerateValidationScore`, request, callback, error);
      },
      ReGenerateValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/ReGenerateValidationScore`, request, callback, error);
      },
      GetTableValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetTableValidationScore`, request, callback, error);
      },
      GetDashboardValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetDashboardValidationScore`, request, callback, error);
      },
      GetRagasDashboardScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetRagasDashboardScore`, request, callback, error);
      },
      GetDDValidationProcess(callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/DDValidationProcess`, callback, error);
      },
      GetValidationProcessDetail(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/GetValidationProcessDetail?ProcessID=${param}`, callback, error);
      },
      DeleteValidationProcess(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationProcess/DeleteValidationProcess?ProcessID=${param}`, callback, error);
      },
      ValidateCSV(formFile, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationProcess/ValidateCSV`, formFile, callback, error);
      },
      GetRelatedScoringRuns(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetRelatedScoringRuns`, request, callback, error);
      },

      //Validation Positive
      GetTableValidationPositive(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/GetTableValidationPositive`, request, callback, error);
      },
      GetTableValidationPositiveDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/GetTableValidationPositiveDetail`, request, callback, error);
      },
      UploadValidationPositive(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationPositive/UploadValidationPositive?name=${request.name}&type=${request.type}`, request.entity, callback, error);
      },
      DeleteValidationPositive(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationPositive/ValidationPositive?name=${request}`, callback, error);
      },
      AddValidationPositiveDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/ValidationPositiveDetailAdd`, request, callback, error);
      },
      EditValidationPositiveDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/ValidationPositiveDetailEdit`, request, callback, error);
      },
      DeleteValidationPositiveDetail(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationPositive/ValidationPositiveDetailDelete?id=${request}`, callback, error);
      },

      //Validation Negative
      GetTableValidationNegative(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationNegative/GetTableValidationNegative`, request, callback, error);
      },
      GetTableValidationNegativeDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationNegative/GetTableValidationNegativeDetail`, request, callback, error);
      },
      UploadValidationNegative(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationNegative/UploadValidationNegative?name=${request.name}`, request.entity, callback, error);
      },
      DeleteValidationNegative(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationNegative/ValidationNegativeDelete?name=${request}`, callback, error);
      },
      DeleteValidationNegativeDetail(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationNegative/ValidationNegativeDetailDelete?id=${request}`, callback, error);
      },

      //#region Folder
      GetFolders(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/GetFolders', request, callback, error);
      },
      GetFolderById(id, callback, error) {
        this.apiGetAuth(`api/v0/Folder/GetFolderById?id=${id}`, callback, error);
      },
      CreateFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/CreateFolder', request, callback, error);
      },
      UpdateFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/UpdateFolder', request, callback, error);
      },
      DeleteFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/DeleteFolder', request, callback, error);
      },
      AddTopicToFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/AddTopicToFolder', request, callback, error);
      },
      RemoveTopicFromFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/RemoveTopicFromFolder', request, callback, error);
      },
      MoveTopicToFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/MoveTopicToFolder', request, callback, error);
      },
      //#endregion

      // Master Data
      GetModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/GetModelData`, request, callback, error);
      },
      GetAllLLMModelData(Token, callback, error) {
        Token = Token == null ? '' : Token;
        this.apiGetToken('api/v0/GPTStream/GetALLModelData', callback, error, Token);
      },
      GetDDLModelData(callback, error) {
        this.apiGetAuth(`api/v0/ModelData/GetDDLModelData`, callback, error);
      },
      CreateModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/CreateModelData`, request, callback, error);
      },
      UpdateModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/UpdateModelData`, request, callback, error);
      },
      DeleteModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/DeleteModelData`, request, callback, error);
      },

      GetPromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/GetPromptTemplate`, request, callback, error);
      },
      AddPromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/AddPromptTemplate`, request, callback, error);
      },
      UpdatePromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/UpdatePromptTemplate`, request, callback, error);
      },
      DeletePromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/DeletePromptTemplate`, request, callback, error);
      },
      GetPromptTemplateReadyUse(callback, error) {
        var request = {};
        this.apiPostAuth(`api/v0/ModelData/GetPromptTemplateReadyUse`, request, callback, error);
      },
      GetProviderData(request, callback, error) {
        this.apiPostAuth(`api/v0/ProviderData/GetProviderData`, request, callback, error);
      },
      GetDDLProviderData(callback, error) {
        this.apiGetAuth(`api/v0/ProviderData/GetDDLProviderData`, callback, error);
      },
      GetKeyJSON(callback, error) {
        var request = {};
        this.apiPostAuth(`api/v0/ModelData/GetKeyJSON`, request, callback, error);
      },

      //#region Stream
      GetTokenFullStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTokenFullStream', request, callback, error);
      },
      ChkTokenFullStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/ChkTokenFullStream', request, callback, error);
      },
      GptFullStreamPOST(request, Config, callback, error) {
        this.apiPostText_Stream('api/v0/GPTStream/GptFullStreamPOST', Config, request, callback, error);
      },
      GptStreamPOST(request, Config, callback, error) {
        this.apiPostText_Stream('api/v0/GPTStream/GptStreamPOST', Config, request, callback, error);
      },
      GetValidationNegativeDD(callback, error) {
        this.apiGetAuth(`api/v0/ValidationNegative/GetValidationNegativeDD`, callback, error);
      },
      GetValidationPositiveDD(callback, error) {
        this.apiGetAuth(`api/v0/ValidationPositive/GetValidationPositiveDD`, callback, error);
      },
      GetValidationPositiveDD2(callback, error) {
        this.apiGetAuth(`api/v0/ValidationPositive/GetValidationPositiveDD2`, callback, error);
      },

      GetLogStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetLogStream', request, callback, error);
      },
      GetLogMonitor(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetLogMonitor', request, callback, error);
      },
      GetTopicID(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTopicID', request, callback, error);
      },

      GptFullStreamPostToken(request, Config, Token, callback, error) {
        this.apiPostTokenText_Stream('api/v0/GPTStream/GptFullStreamPOST', Config, request, callback, error, Token);
      },
      ChatPlayGroundStreamPOST(request, Config, callback, error) {
        this.apiPostText_Stream('api/v0/GPTStream/ChatPlayGroundStreamPOST', Config, request, callback, error);
      },
      GetTaxStatePlayground(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTaxStatePlayground', request, callback, error);
      },

      GetModelQuickGroupInModelGroup(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetModelQuickGroupInModelGroup', request, callback, error, Token);
      },
      GetShortcutMenu(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetShortcutMenu', request, callback, error, Token);
      },
      //#endregion

      //#region Speech_To_Text
      GetModelQuickGroupInModelGroupPostToken(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetModelQuickGroupInModelGroup', request, callback, error, Token);
      },

      // Speech_To_Text
      GetConvest_Speech_To_Text(request, Config, callback, error) {
        this.apiPostImportFileAuth('api/v0/SpeechToText/Convest_Speech_To_Text', request, Config, callback, error);
      },
      GetSpeechDocument(request, callback, error) {
        this.apiPostAuth('api/v0/SpeechToText/SpeechDocumentShow', request, callback, error);
      },
      CreateSpeechDocument(request, config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/SpeechToText/CreateSpeechDocument`, request, config, callback, error);
      },
      UploadSpeechDocument(request, config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/SpeechToText/UploadSpeechDocument`, request, config, callback, error);
      },
      GetSpeechDocumentDetail(request, callback, error) {
        this.apiPostAuth('api/v0/SpeechToText/GetSpeechDocumentDetail', request, callback, error);
      },
      EditSpeechDocumentDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/SpeechToText/EditSpeechDocument`, request, callback, error);
      },
      DeleteSpeechDocument(param, callback, error) {
        this.apiDeleteAuth(`api/v0/SpeechToText/DeleteSpeechDocument?id=${param}`, callback, error);
      },
      DeleteSpeechDocumentDetail(param, callback, error) {
        this.apiDeleteAuth(`api/v0/SpeechToText/DeleteSpeechDocumentDetail?id=${param}`, callback, error);
      },
      ImportSpeech2Text(request, callback, error) {
        this.apiPostAuth(`api/v0/Chat/ImportSpeech2Text`, request, callback, error);
      },
      SummarizedSpeechDocumentDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/SpeechToText/SummarizedSpeechDocumentDetail`, request, callback, error);
      },
      //#endregion

      //#region History
      GetHistoryStream(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/GetHistoryStream', request, callback, error);
      },
      GetHistoryFullStream(request, token, callback, error) {
        this.apiPostAuthNoAlertToken('api/v0/GPTStream/GetHistoryFullStream', request, callback, error, token);
      },
      // GetLastLogID(request, callback, error) {
      //   this.apiPostAuthNoAlert('api/v0/GPTStream/GetLastLogID', request, callback, error);
      // },
      GetLastLogID(request, token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetLastLogID', request, callback, error, token);
      },

      GetTopicStream(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/GetTopicStream', request, callback, error);
      },
      GetTopicFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetTopicFullStream', request, callback, error, Token);
      },

      GetTopicStreamToken(request, Token, callback, error) {
        Token = Token == null ? '' : Token;
        this.apiPostAuthNoAlertToken('api/v0/GPTStream/GetTopicFullStream', request, callback, error, Token);
      },

      // RenameTopicStream(request, callback, error) {
      //   this.apiPostAuthNoAlert('api/v0/GPTStream/RenameTopicStream', request, callback, error);
      // },
      RenameTopicStream(request, Token, callback, error) {
        Token = Token == null ? '' : Token;
        this.apiPostToken('api/v0/GPTStream/RenameTopicStream', request, callback, error, Token);
      },
      DeleteTopicStream(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/DeleteTopicStream', request, callback, error);
      },

      GetTopicIDStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTopicIDStream', request, callback, error);
      },
      //#endregion

      //#region Private Memory

      GetDDGroupReplaceDB_Stream(callback, error) {
        this.apiGetAuth('api/v0/GPTStream/GetDDGroupReplaceDBStream', callback, error);
      },
      GetDDGroupReplaceDB_FullStream(Token, callback, error) {
        this.apiGetToken('api/v0/GPTStream/GetDDGroupReplaceDBFullStream', callback, error, Token);
      },
      UploadImage_Stream(request, callback, error) {
        let url = `api/v0/GPTStream/UploadImageFileStream?USER_CHANNEL=${request.USER_CHANNEL}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      UploadImage_FullStream(request, Token, callback, error) {
        let url = `api/v0/GPTStream/UploadImageFileFullStream?USER_CHANNEL=${request.USER_CHANNEL}`;
        this.apiPostTypeFileNoResponseToken(url, request.entity, callback, error, Token);
      },
      // UploadCSV2Vector_Stream(request, callback, error) {
      //   let url =  `api/v0/GPTStream/UploadFile?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
      //   if(request.customCharacter != null){
      //     url += `&customCharacter=${request.customCharacter}`;
      //   }
      //   if (request.groupReplaceID != null) {
      //     url += `&groupReplaceID=${request.groupReplaceID}`;
      //   }
      //   if (request.MaxLimitedCharacter != null) {
      //     url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
      //   }
      //   this.apiPostTypeFileNoResponseAuth(
      //     url,
      //     request.entity,
      //     callback,
      //     error
      //   );
      // },
      // UploadCSV2Vector_FullStream(request, callback, error) {
      //   let url =  `api/v0/GPTStream/UploadFileFullStream?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
      //   if(request.customCharacter != null){
      //     url += `&customCharacter=${request.customCharacter}`;
      //   }
      //   if (request.groupReplaceID != null) {
      //     url += `&groupReplaceID=${request.groupReplaceID}`;
      //   }
      //   if (request.MaxLimitedCharacter != null) {
      //     url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
      //   }
      //   this.apiPostTypeFileNReFreshVector_FullStreamoResponseAuth(
      //     url,
      //     request.entity,
      //     callback,
      //     error
      //   );
      // },

      ReFreshVector_Stream(request, Config, callback, error) {
        this.apiPostAuthNoAlert_Config('api/v0/GPTStream/ReFreshVector_Stream', request, Config, callback, error);
      },
      ReFreshVector_FullStream(request, Config, Token, callback, error) {
        this.apiPostTokenText_Stream('api/v0/GPTStream/ReFreshVector_FullStream', Config, request, callback, error, Token);
      },
      // ReProcessedVector_Stream(request, callback, error) {
      //   this.apiPostAuth('api/v0/GPTStream/ReProcessed', request, callback, error);
      // },
      // ReProcessedVector_FullStream(request, callback, error) {
      //   this.apiPostAuth('api/v0/GPTStream/ReProcessedFullStream', request, callback, error);
      // },
      SaveEditVector_Stream(request, callback, error) {
        this.apiPostAuth(`api/v0/GPTStream/SaveEditVectorPrivateStream`, request, callback, error);
      },
      SaveEditVector_FullStream(request, Token, callback, error) {
        this.apiPostToken(`api/v0/GPTStream/SaveEditVectorPrivateFullStream`, request, callback, error, Token);
      },
      SaveAddVector_Stream(request, callback, error) {
        this.apiPostAuth(`api/v0/GPTStream/SaveAddVectorPrivateStream`, request, callback, error);
      },
      SaveAddVector_FullStream(request, Token, callback, error) {
        this.apiPostToken(`api/v0/GPTStream/SaveAddVectorPrivateFullStream`, request, callback, error, Token);
      },

      Delete_ListFilePM_ById_Stream(param, callback, error) {
        this.apiDeleteAuth(`api/v0/GPTStream/Delete_ListFilePM_ById_Stream?id=${param}`, callback, error);
      },
      Delete_ListFilePM_ById_FullStream(param, Token, callback, error) {
        this.apiDeleteToken(`api/v0/GPTStream/Delete_ListFilePM_ById_FullStream?id=${param}`, callback, error, Token);
      },
      DeleteVectorDBNameById_Stream(param, callback, error) {
        this.apiDeleteAuth(`api/v0/GPTStream/DeleteVectorDBNameById_Stream?id=${param}`, callback, error);
      },
      DeleteVectorDBNameById_FullStream(param, Token, callback, error) {
        this.apiDeleteToken(`api/v0/GPTStream/DeleteVectorDBNameById_FullStream?id=${param}`, callback, error, Token);
      },
      DeleteVectorDBNameByName_Stream(param, callback, error) {
        this.apiDeleteAuth(`api/v0/GPTStream/DeleteVectorDBNameByName_Stream?vectorDBName=${param.name}&FileId=${param.FileId}`, callback, error);
      },
      DeleteVectorDBNameByName_FullStream(param, Token, callback, error) {
        this.apiDeleteToken(`api/v0/GPTStream/DeleteVectorDBNameByName_FullStream?vectorDBName=${param.name}&FileId=${param.FileId}`, callback, error, Token);
      },
      SaveCosine_TopVDBStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/SaveCosine_TopVDBStream', request, callback, error);
      },
      SaveCosine_TopVDBFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/SaveCosine_TopVDBFullStream', request, callback, error, Token);
      },
      SaveFileName_PrivateMemoryStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/SaveFileName_PrivateMemoryStream', request, callback, error);
      },
      SaveFileName_PrivateMemoryFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/SaveFileName_PrivateMemoryFullStream', request, callback, error, Token);
      },
      CancelFileName_PrivateMemory(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/CancelFileName_PrivateMemory', request, callback, error);
      },
      GetListFile_PrivateMemoryStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetListFile_PrivateMemoryStream', request, callback, error);
      },
      GetListFile_PrivateMemoryFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetListFile_PrivateMemoryFullStream', request, callback, error, Token);
      },

      //#endregion

      // ExternalAPI
      GetCheckAnonymous(callback, error) {
        var request = {};
        this.apiPostAuth(`api/v0/ExternalAPI/GetCheckAnonymous`, request, callback, error);
      },

      GetModelFirst(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/GetModelFirst', request, callback, error);
      },

      //Report
      GetReportQuestion(request, callback, error) {
        this.apiPostAuth('api/v0/Report/ReportQuestionTop10', request, callback, error);
      },
      QuestionGenerate(request, callback, error) {
        this.apiPostAuth('api/v0/Report/QuestionGenerate', request, callback, error);
      },
      ReportUser(request, callback, error) {
        this.apiPostAuth('api/v0/Report/ReportUserTop10', request, callback, error);
      },
      ReportUserUse(request, callback, error) {
        this.apiPostAuth('api/v0/Report/ReportUserUse', request, callback, error);
      },
      ExportReportUserUse(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/Report/ExportReportUserUse', request, callback, error);
      },
      ReportTokenSum(request, callback, error) {
        this.apiPostAuth('api/v0/Report/TotalToken', request, callback, error);
      },
      ExportReportTokenSummation(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/Report/ExportReportTokenSummation', request, callback, error);
      },
      //APIToken

      GetAPITokenData(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/GetAPITokenData`, request, callback, error);
      },
      RenewAPIToken(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/RenewAPIToken`, request, callback, error);
      },
      CreateAPIToken(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/CreateAPIToken`, request, callback, error);
      },
      RevorkAPIToken(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/RevorkAPIToken`, request, callback, error);
      },

      // ReleaseNote
      GetReleaseNote(callback, error) {
        this.apiGetAuth(`api/v0/ReleaseNote/GetReleaseNote`, callback, error);
      },

      // Feedback
      FeedbackFromClient(request, callback, error) {
        var Token = request.token;
        this.apiPostToken(`api/v0/Feedback/FeedbackFromClient`, request.data, callback, error, Token);
      },
      GetTableReportFeedback(request, callback, error) {
        this.apiPostAuth(`api/v0/Feedback/GetTableReportFeedback`, request, callback, error);
      },
      ExportReportFeedback(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Feedback/ExportReportFeedback`, request, callback, error);
      },
      //#region ConfigTheme
      SaveConfigTheme(request, callback, error) {
        this.apiPostAuth(`api/v0/ConfigTheme/SaveConfigTheme`, request, callback, error);
      },
      UploadTheme(param, callback, error) {
        this.apiPostImportFile(
          `api/v0/ConfigTheme/upload?ChatbotName=${param.ChatbotName}&ChatbotIcon=${param.ChatbotIcon}&FontColorTitle=${param.FontColorTitle}&chatColorTheme=${param.chatColorTheme}&NavbarBtnColorTheme=${param.NavbarBtnColorTheme}&NavbarTxtColorTheme=${param.NavbarTxtColorTheme}&setDefaultJson=${param.setDefaultJson}`,
          param.formData,
          callback,
          error
        );
      },
      GetImage(filename, callback, error) {
        this.apiGetBlobAuthData(`api/v0/ConfigTheme/GetImage/${filename}`, callback, error);
      },
      GetConfigThem(callback, error) {
        this.apiGetAuth(`api/v0/ConfigTheme/GetConfigThem`, callback, error);
      },
      SetDefault(callback, error) {
        let request = {};
        this.apiPostAuth(`api/v0/ConfigTheme/setDefault`, request, callback, error);
      },
      //#endregoion

      //#region ConsentConfig
      GetConsentConfig(callback, error) {
        this.apiGetAuth(`api/v0/ConsentConfig/GetConsentConfig`, callback, error);
      },
      UpdateConsent(request, callback, error) {
        this.apiPostAuth('api/v0/ConsentConfig/UpdateConsent', request, callback, error);
      },
      GetViewVersion(callback, error) {
        this.apiGetAuth(`api/v0/ConsentConfig/GetViewVersion`, callback, error);
      },
      GetConsentById(request, callback, error) {
        this.apiPostAuth(`api/v0/ConsentConfig/GetConsentById`, request, callback, error);
      },
      //#endregoion

      //#region PromptTemplate
      GetTableGroupPromptTemplate(callback, error) {
        this.apiPostAuth(`api/v0/GroupPromptTemplate/GetTableGroupPromptTemplate`, callback, error);
      },
      DeleteGroupPromptTemplate(id, callback, error) {
        this.apiDeleteAuth(`api/v0/GroupPromptTemplate/DeleteGroupPromptTemplate?id=${id}`, callback, error);
      },
      //#endregion

      //#region File Management
      DownloadChatImage(request, token, callback, error) {
        if (token) {
          this.apiPostImageAuth('api/v0/GPTStream/DownloadChatImage', request, callback, error, token);
        } else {
          this.apiPostImageAuth('api/v0/FileManager/DownloadChatImage', request, callback, error);
        }
      },
      GetTableFileManager(request, callback, error) {
        this.apiPostAuth('api/v0/FileManager/GetTableFileManager', request, callback, error);
      },
      DeleteFileManager(id, callback, error) {
        this.apiDeleteAuth(`api/v0/FileManager/DeleteFileManager?id=${id}`, callback, error);
      },
      DeleteAllFileManager(fileIds, callback, error) {
        this.apiDeleteFileAuth(`api/v0/FileManager/DeleteAllFileManager`, fileIds, callback, error);
      },
      GetViewFileManagerById(id, callback, error) {
        this.apiPostAuth(`api/v0/FileManager/GetViewFileManagerById?id=${id}`, null, callback, error);
      },
      //#endregion

      //#region SecurityGroup

      GetTableSecurityGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/GetTableSecurityGroup`, request, callback, error);
      },
      AddSecurityGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/AddSecurityGroup`, request, callback, error);
      },
      SyncDataEntraIDGroup(id, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/SyncDataEntraIDGroup?id=${id}`, null, callback, error);
      },
      GetTableUserGroupManagement(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/GetTableUserGroupManagement`, request, callback, error);
      },
      DeleteSecurityGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/SecurityGroup/Delete?id=${id}`, callback, error);
      },
      GetTableSetupUserGroupManagement(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/GetTableSetupUserGroupManagement`, request, callback, error);
      },
      GetSetupByID(id, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/GetSetupByID?id=${id}`, null, callback, error);
      },
      DeleteUserByID(param, callback, error) {
        this.apiDeleteAuth(`api/v0/SecurityGroup/DeleteUserByID?id=${param.id}&GroupID=${param.groupid}`, callback, error);
      },
      UpdateUserGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/UpdateUserGroup`, request, callback, error);
      },
      AddUserIntoGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/AddUserIntoGroup`, request, callback, error);
      },
      //#endregion
      SendFileMessage(request, config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/ChatHub/SendFileMessage?topic=${request.topic}&type=${request.type}`, request.files, config, callback, error);
      },

      // #region ShortcutMenu
      CreateShortcutMenuGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ShortcutMenu/CreateShortcutMenuGroup`, request, callback, error);
      },
      UpdateShortcutMenuGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ShortcutMenu/UpdateShortcutMenuGroup`, request, callback, error);
      },
      GetTableShortcutMenuGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ShortcutMenu/GetTableShortcutMenuGroup`, request, callback, error);
      },
      DeleteShortcutMenuGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ShortcutMenu/DeleteShortcutMenuGroup?id=${id}`, callback, error);
      },
      GetShortcutMenuByID(param, callback, error) {
        this.apiGetAuth(`api/v0/ShortcutMenu/GetShortcutMenuByID?id=${param}`, callback, error);
      },
      GetDDShortcutMenu(callback, error) {
        this.apiGetAuth(`api/v0/ShortcutMenu/GetDDShortcutMenu`, callback, error);
      },

      // #region Product
      GetDDProductGroupList(callback, error) {
        this.apiGetAuth(`api/v0/Product/GetDDProductGroupList`, callback, error);
      },
      GetTableProductGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Product/GetTableProductGroup`, request, callback, error);
      },
      GetProductDetailById(param, callback, error) {
        this.apiGetAuth(`api/v0/Product/GetProductDetailById?id=${param}`, callback, error);
      },
      CreateCategory(request, callback, error) {
        this.apiPostAuth(`api/v0/Product/CreateCategory`, request, callback, error);
      },
      CreateProduct(request, callback, error) {
        this.apiPostImportFile(`api/v0/Product/CreateProduct`, request, callback, error);
      },
      UpdateProductGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Product/UpdateProductGroup`, request, callback, error);
      },
      DeleteProductGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/Product/DeleteProductGroup`, request, callback, error);
      },
      DeleteProduct(request, callback, error) {
        this.apiPostAuth(`api/v0/Product/DeleteProduct`, request, callback, error);
      },
      ReprocessVectorProduct(request, callback, error) {
        this.apiPostAuth(`api/v0/Product/ReprocessVectorProduct`, request, callback, error);
      },

      setCookie(name, value) {
        // var expires = "";
        // if (days) {
        // var date = new Date();
        // date.setTime(date.getTime() + (days*24*60*60*1000));
        // expires = "; expires=" + date.toUTCString();
        // }
        // document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        document.cookie = name + '=' + (value || '');
      },
      getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      },
      eraseCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      },

      ClearUserInfo() {
        Object.keys(Cookies.get()).forEach(function (cookieName) {
          if (cookieName != 'rememberMe') {
            Cookies.remove(cookieName);
          }
        });
        localStorage.removeItem('customPagePermission');
      },
      Logout() {
        this.apiPostAuth(
          'api/v0/Login/signout',
          null,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.ClearUserInfo();
              router.push('/login');
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
        );
      },
      ChatLogout() {
        Object.keys(Cookies.get()).forEach(function (cookieName) {
          if (cookieName != 'rememberMe') {
            Cookies.remove(cookieName);
          }
        });
      },
      GetUserInfo() {
        let Usid = Cookies.get('UserId');
        let Codeid = Cookies.get('UserCode');
        let UserFullName = Cookies.get('UserName');

        let temp = parseInt(Usid);
        return {
          UserId: temp,
          UserCode: Codeid,
          UserName: UserFullName,
        };
      },
      images: {
        logout: logoutImage,
      },
      apiPostLogin(URL, request, callback, error) {
        const instance = axios.create({
          timeout: 500000,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              Cookies.set('userId', response.data.data.userId);
              Cookies.set('username', response.data.data.username);
              Cookies.set('fullName', response.data.data.fullName);
              Cookies.set('roleId', response.data.data.roleId);
              Cookies.set('roleId', response.data.data.roleId);
              Cookies.set('authenticated', true);
              store.state.status = 'success';
              store.state.token = response.data.data.token;
              store.state.userid = response.data.data.userId;
              store.state.username = response.data.data.username;
              store.state.user = response.data.data;
              store.state.fullName = response.data.data.fullName;
              store.state.roleId = response.data.data.roleId;
              store.state.isLoggedIn = true;
              // Custom Page Permission — stored as [{ key, mode, actions: { add, edit, delete } }].
              // Tolerate legacy string[] and intermediate { key, mode } from older API/storage.
              if (response.data.data.isCustomPageAccess) {
                const raw = response.data.data.customPagePermission || [];
                const fullActions = () => ({ add: true, edit: true, delete: true });
                const noActions = () => ({ add: false, edit: false, delete: false });
                const normalizeActions = (a) => {
                  if (!a || typeof a !== 'object') return fullActions();
                  return {
                    add: a.add !== false,
                    edit: a.edit !== false,
                    delete: a.delete !== false,
                  };
                };
                const normalized = Array.isArray(raw)
                  ? raw
                      .map((entry) => {
                        if (typeof entry === 'string') {
                          return { key: entry, mode: 'edit', actions: fullActions() };
                        }
                        if (entry && typeof entry === 'object' && typeof entry.key === 'string') {
                          const mode = entry.mode === 'view' ? 'view' : 'edit';
                          const actions = mode === 'view' ? noActions() : normalizeActions(entry.actions);
                          return { key: entry.key, mode, actions };
                        }
                        return null;
                      })
                      .filter(Boolean)
                  : [];
                Cookies.set('isCustomPageAccess', 'true');
                localStorage.setItem('customPagePermission', JSON.stringify(normalized));
              } else {
                Cookies.remove('isCustomPageAccess');
                localStorage.removeItem('customPagePermission');
              }
              localStorage.setItem('flag', 'us');
              localStorage.setItem('locale', 'en');
              store.state.languages = 'en';
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            return error(response);
          });
      },
      apiPostLoginChat(URL, request, callback, error) {
        const instance = axios.create({
          timeout: 500000,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              Object.keys(Cookies.get()).forEach(function (cookieName) {
                if (cookieName != 'rememberMe') {
                  Cookies.remove(cookieName);
                }
              });
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            return error(response);
          });
      },

      apiPostAuth(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          withCredentials: true,
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            console.error('Unexpected Status:', response.status); // ฝรณี status ไม่ใช่ 200
            return error(response);
          })
          .catch((response) => {
            console.error('API Error:', response.response); // ข้อผิดพลาดจาก API
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }

            //else if(response.response.status === 400)
            //{
            //  console.log("Call 400");
            //  router.push('/login');
            //}
            else {
              Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'Something went wrong!',
                showConfirmButton: false,
                timer: 1500,
              });
              return error(response);
            }
          });
      },

      apiPostLoginLHB(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          withCredentials: true,
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            console.error('Unexpected Status:', response.status); // ฝรณี status ไม่ใช่ 200
            return error(response);
          })
          .catch((response) => {
            console.error('API Error:', response.response); // ข้อผิดพลาดจาก API
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }

            //else if(response.response.status === 400)
            //{
            //  console.log("Call 400");
            //  router.push('/login');
            //}
            else {
              Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'Something went wrong!',
                showConfirmButton: false,
                timer: 1500,
              });
              return error(response);
            }
          });
      },
      apiPostImageAuth(URL, request, callback, error, Token) {
        let self = this;
        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json-patch+json; charset=utf-8',
        };

        if (Token) {
          headers.Authorization = 'Bearer ' + Token;
        }

        const instance = axios.create({
          headers: headers,
          responseType: 'blob',
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            console.error('Unexpected Status:', response.status); // ฝรณี status ไม่ใช่ 200
            return error(response);
          })
          .catch((response) => {
            console.error('API Error:', response.response); // ข้อผิดพลาดจาก API
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            //else if(response.response.status === 400)
            //{
            //  console.log("Call 400");
            //  router.push('/login');
            //}
            else {
              Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด',
                text: 'Something went wrong!',
                showConfirmButton: false,
                timer: 1500,
              });
              return error(response);
            }
          });
      },

      apiMultiPostAuth(URL, request, callback, error) {
        let self = this;
        let formData = new FormData();
        formData.append('request', request);
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },

      apiPostAuthNoAlert_Config(URL, request, Config, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request, Config)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            return error(response);
          });
      },
      apiPostAuthNoAlert(URL, request, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            return error(response);
          });
      },
      apiPostAuthNoAlertToken(URL, request, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 403) {
              router.push('/AccessDenied');
              Swal.fire({
                //iconHtml: '<img style="width: 100%;" alt="edit" src="'+ self.images.logout +'" v-bind="attrs" v-on="on">',
                icon: 'error',
                title: 'Access Denied',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            return error(response);
          });
      },
      apiPutAuth(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .put(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPutTypeFileNoResponseAuth(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // Leave Content-Type unset so Axios supplies the multipart boundary.
          },
        });
        instance
          .put(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPatchAuth(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .patch(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostTypeFileAuth(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
          responseType: 'blob',
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostTypeFileToken(URL, request, callback, error, Token) {
        let self = this;
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            //'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          responseType: 'blob',
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiGetTypeFileAuth(URL, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
          responseType: 'blob',
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostTypeFileNoResponseAuth(URL, request, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostTypeFileMultipart(URL, request, callback, error) {
        let self = this;
        const jsonBody = {
          vectorDBName: request.vectordbName,
          modelType: request.modelType,
          deleteAll: request.deleteAll,
          customCharacter: request.customCharacter,
          topVDB: request.topVDB,
          cosine: request.cosine,
          topicID: request.TopicID,
          userChannel: request.USER_CHANNEL,
          groupReplaceID: request.groupReplaceID,
          detectLanguage: request.DetectLanguage,
          fileId: request.fileId,
          fileName: request.searchVectorDBName2,
          maxLimitedCharacter: request.MaxLimitedCharacter,
        };
        request.entity.append('jsonBody', JSON.stringify(jsonBody));

        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // "Content-Type": "multipart/form-data"
          },
        });
        instance
          .post(this.urlApi + URL, request.entity)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostTypeFileNoResponseToken(URL, request, callback, error, Token) {
        let self = this;
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostToken(URL, request, callback, error, Token) {
        let self = this;
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            } else if (response.response != undefined && response.response.status === 403) {
              router.push('/AccessDenied');
              Swal.fire({
                //iconHtml: '<img style="width: 100%;" alt="edit" src="'+ self.images.logout +'" v-bind="attrs" v-on="on">',
                icon: 'error',
                title: 'Access Denied',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiGetBlobAuth(URL, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          responseType: 'blob',
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },

      apiGetBlobAuthData(URL, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          responseType: 'blob',
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiGetAuth(URL, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          withCredentials: true,
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiGetToken(URL, callback, error, Token) {
        let self = this;
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            } else if (response.response != undefined && response.response.status === 403) {
              router.push('/AccessDenied');
              Swal.fire({
                //iconHtml: '<img style="width: 100%;" alt="edit" src="'+ self.images.logout +'" v-bind="attrs" v-on="on">',
                icon: 'error',
                title: 'Access Denied',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiDeleteAuth(URL, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .delete(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiDeleteToken(URL, callback, error, Token) {
        let self = this;
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .delete(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiDeleteFileAuth(URL, fileIds, callback, error) {
        let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .delete(this.urlApi + URL, {
            data: fileIds,
          })
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            if (response.response != undefined && response.response.status === 401) {
              // if (response.status === 401) {
              self.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="' + self.images.logout + '" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border',
                },
              });
              return error(response);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(response);
          });
      },
      apiPostText_Stream(URL, Config, request, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request, Config)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            //      if (response.response != undefined && response.response.status === 401) {
            // if (response.status === 401) {

            //   return error(response);
            // }
            return error(response);
          });
      },
      apiPostTokenText_Stream(URL, Config, request, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request, Config)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            //      if (response.response != undefined && response.response.status === 401) {
            // if (response.status === 401) {

            //   return error(response);
            // }
            return error(response);
          });
      },

      apiPostImportFileAuth(URL, request, Config, callback, error) {
        // let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
          },
        });
        instance
          .post(this.urlApi + URL, request, Config)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            return error(response);
          });
      },

      apiPostImportFile(URL, request, callback, error) {
        // let self = this;
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'form-data',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            return error(response);
          })
          .catch((response) => {
            return error(response);
          });
      },

      //ProactiveMessage
      GetTableProactiveMessage(request, callback, error) {
        this.apiPostAuth('api/v1/ProactiveMessage/search', request, callback, error);
      },
      GetProactiveMessageById(id, callback, error) {
        this.apiGetAuth(`api/v1/ProactiveMessage/${id}`, callback, error);
      },
      CreateProactiveMessage(request, callback, error) {
        this.apiPostAuth('api/v1/ProactiveMessage', request, callback, error);
      },
      UpdateProactiveMessage(id, request, callback, error) {
        this.apiPutAuth(`api/v1/ProactiveMessage/${id}`, request, callback, error);
      },
      DeleteProactiveMessage(id, callback, error) {
        this.apiDeleteAuth(`api/v1/ProactiveMessage/${id}`, callback, error);
      },
      GetProactiveMessageOptions(callback, error) {
        this.apiGetAuth('api/v1/ProactiveMessage/options', callback, error);
      },
      UploadCifFile(request, callback, error) {
        this.apiPostImportFileAuth('api/v1/ProactiveMessage/upload-cif', request, null, callback, error);
      },
      DownloadCifFile(fileUrl, fileName, callback, error) {
        const query = `fileUrl=${encodeURIComponent(fileUrl)}&fileName=${encodeURIComponent(fileName || '')}`;
        this.apiGetBlobAuth(`api/v1/ProactiveMessage/download-cif?${query}`, callback, error);
      },
      ExportProactiveMessage(request, callback, error) {
        this.apiPostTypeFileAuth('api/v1/ProactiveMessage/export', request, callback, error);
      },

      //BarManagement
      // CIF upload/download reuses UploadCifFile / DownloadCifFile above: that endpoint is not tied
      // to any one feature and returns the same FileUrl / FileName / CifList / CifCount shape.
      GetTableBarManagement(request, callback, error) {
        this.apiPostAuth('api/v1/BarManagement/search', request, callback, error);
      },
      GetBarManagementById(id, callback, error) {
        this.apiGetAuth(`api/v1/BarManagement/${id}`, callback, error);
      },
      CreateBarManagement(request, callback, error) {
        this.apiPostAuth('api/v1/BarManagement', request, callback, error);
      },
      UpdateBarManagement(id, request, callback, error) {
        this.apiPutAuth(`api/v1/BarManagement/${id}`, request, callback, error);
      },
      DeleteBarManagement(id, callback, error) {
        this.apiDeleteAuth(`api/v1/BarManagement/${id}`, callback, error);
      },
      GetBarManagementOptions(callback, error) {
        this.apiGetAuth('api/v1/BarManagement/options', callback, error);
      },
      UploadBarManagementIcon(request, callback, error) {
        let url = `api/v1/BarManagement/UploadIcon?USER_CHANNEL=${request.USER_CHANNEL}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },

      //SystemConfig
      GetSystemConfigOverview(callback, error) {
        this.apiGetAuth('api/v1/SystemConfig/overview', callback, error);
      },
      GetSystemConfigLanguages(callback, error) {
        this.apiGetAuth('api/v1/SystemConfig/languages', callback, error);
      },
      CreateLanguageConfig(request, callback, error) {
        this.apiPostAuth('api/v1/SystemConfig/languages', request, callback, error);
      },
      UpdateLanguageConfig(id, request, callback, error) {
        this.apiPutAuth(`api/v1/SystemConfig/languages/${id}`, request, callback, error);
      },
      DeleteLanguageConfig(id, callback, error) {
        this.apiDeleteAuth(`api/v1/SystemConfig/languages/${id}`, callback, error);
      },
      SetDefaultLanguage(languageCode, callback, error) {
        this.apiPostAuth(`api/v1/SystemConfig/languages/${languageCode}/set-default`, null, callback, error);
      },
      ToggleVoiceFeature(request, callback, error) {
        this.apiPostAuth('api/v1/SystemConfig/features/voice', request, callback, error);
      },
      GetSystemConfigs(callback, error) {
        this.apiGetAuth('api/v1/SystemConfig/configs', callback, error);
      },
      CreateSystemConfig(request, callback, error) {
        this.apiPostAuth('api/v1/SystemConfig/configs', request, callback, error);
      },
      UpdateSystemConfig(configKey, request, callback, error) {
        this.apiPutAuth(`api/v1/SystemConfig/configs/${configKey}`, request, callback, error);
      },

      // Mobile Configuration APIs
      GetMobileConfigurations(callback, error) {
        this.apiGetAuth('api/v0/MobileConfiguration/GetAll', callback, error);
      },
      GetMobileConfigurationById(id, callback, error) {
        this.apiGetAuth(`api/v0/MobileConfiguration/GetById/${id}`, callback, error);
      },
      GetMobileConfigurationByCompanyId(request, callback, error) {
        this.apiPostAuth('api/v0/MobileConfiguration/GetByCompanyId', request, callback, error);
      },
      CreateMobileConfiguration(request, callback, error) {
        this.apiPostAuth('api/v0/MobileConfiguration/Create', request, callback, error);
      },
      UpdateMobileConfiguration(request, callback, error) {
        this.apiPutAuth('api/v0/MobileConfiguration/Update', request, callback, error);
      },
      // #786 — Wake word tab: the whole list, saved on its own after each confirmed add / edit / delete
      SaveMobileConfigurationWakeWords(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/MobileConfiguration/WakeWords/${mobileConfigId}`, request, callback, error);
      },
      GetMobileConfigurationHistory(mobileConfigId, page, pageSize, filter, callback, error) {
        const query = new URLSearchParams({ page, pageSize });
        if (filter?.startDateUtc) query.set('startDateUtc', filter.startDateUtc);
        if (filter?.endDateExclusiveUtc) query.set('endDateExclusiveUtc', filter.endDateExclusiveUtc);
        if (filter?.username) query.set('username', filter.username);
        if (filter?.tab) query.set('tab', filter.tab);
        this.apiGetAuth(`api/v0/MobileConfiguration/History/${mobileConfigId}?${query.toString()}`, callback, error);
      },
      GetMobileConfigurationHistoryDetail(mobileConfigId, historyId, callback, error) {
        this.apiGetAuth(`api/v0/MobileConfiguration/History/${mobileConfigId}/${historyId}`, callback, error);
      },
      SaveMobileConfigurationHistory(request, callback, error) {
        this.apiPostAuth('api/v0/MobileConfiguration/History', request, callback, error);
      },
      DeleteMobileConfiguration(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MobileConfiguration/Delete/${id}`, callback, error);
      },
      SearchMobileConfigurations(request, callback, error) {
        this.apiPostAuth('api/v0/MobileConfiguration/Search', request, callback, error);
      },
      GetMobileConfigurationOptions(callback, error) {
        this.apiGetAuth('api/v0/MobileConfiguration/options', callback, error);
      },

      // Suggestion Features
      GetSuggestionFeatures(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/MobileConfiguration/SuggestionFeatures/${mobileConfigId}`, callback, error);
      },
      CreateSuggestionFeature(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/MobileConfiguration/SuggestionFeatures/${mobileConfigId}`, request, callback, error);
      },
      UpdateSuggestionFeature(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/MobileConfiguration/SuggestionFeatures/${mobileConfigId}`, request, callback, error);
      },
      DeleteSuggestionFeature(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MobileConfiguration/SuggestionFeatures/${id}`, callback, error);
      },
      GetSuggestionActions(callback, error) {
        this.apiGetAuth('api/v0/MobileConfiguration/SuggestionActions', callback, error);
      },

      // Suggestion Action admin management (shared by LH Bank and Tax Planning config pages)
      GetSuggestionActionsAdmin(isTaxPlanningMode, includeInactive, callback, error) {
        const url = `api/v1.0/SuggestionAction?isTaxPlanningMode=${isTaxPlanningMode}&includeInactive=${includeInactive}`;
        this.apiGetAuth(url, callback, error);
      },
      BulkSaveSuggestionActionChanges(request, callback, error) {
        this.apiPostAuth('api/v1.0/SuggestionAction/BulkSave', request, callback, error);
      },

      // Suggestion Questions
      GetSuggestionQuestions(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/MobileConfiguration/SuggestionQuestions/${mobileConfigId}`, callback, error);
      },
      CreateSuggestionQuestion(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/MobileConfiguration/SuggestionQuestions/${mobileConfigId}`, request, callback, error);
      },
      UpdateSuggestionQuestion(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/MobileConfiguration/SuggestionQuestions/${mobileConfigId}`, request, callback, error);
      },
      DeleteSuggestionQuestion(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MobileConfiguration/SuggestionQuestions/${id}`, callback, error);
      },

      // Genie AI Characters
      GetGenieAICharacters(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/MobileConfiguration/GenieAICharacters/${mobileConfigId}`, callback, error);
      },
      CreateGenieAICharacter(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/MobileConfiguration/GenieAICharacters/${mobileConfigId}`, request, callback, error);
      },
      UpdateGenieAICharacter(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/MobileConfiguration/GenieAICharacters/${mobileConfigId}`, request, callback, error);
      },
      DeleteGenieAICharacter(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MobileConfiguration/GenieAICharacters/${id}`, callback, error);
      },
      UploadGenieCharacterIcon(request, callback, error) {
        let url = `api/v0/MobileConfiguration/GenieAICharacters/UploadIcon?USER_CHANNEL=${request.USER_CHANNEL}&genieField=${request.genieField}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },

      // Tax Dialogs — fixed dialog types, no create/delete · id = TaxPlanningMobileConfiguration ID (#667)
      GetTaxDialogs(taxMobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/TaxPlanningMobileConfiguration/TaxDialogs/${taxMobileConfigId}`, callback, error);
      },
      UpdateTaxDialog(taxMobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/TaxPlanningMobileConfiguration/TaxDialogs/${taxMobileConfigId}`, request, callback, error);
      },
      UploadTaxDialogIcon(request, callback, error) {
        let url = `api/v0/TaxPlanningMobileConfiguration/TaxDialogs/UploadIcon?USER_CHANNEL=${request.USER_CHANNEL}&dialogTypeCode=${request.dialogTypeCode}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },

      // Tax Planning Mobile Configuration APIs
      GetTaxPlanningMobileConfigurationByCompanyId(request, callback, error) {
        this.apiPostAuth('api/v0/TaxPlanningMobileConfiguration/GetByCompanyId', request, callback, error);
      },
      CreateTaxPlanningMobileConfiguration(request, callback, error) {
        this.apiPostAuth('api/v0/TaxPlanningMobileConfiguration/Create', request, callback, error);
      },
      UpdateTaxPlanningMobileConfiguration(request, callback, error) {
        this.apiPutAuth('api/v0/TaxPlanningMobileConfiguration/Update', request, callback, error);
      },

      // Tax Planning Suggestion Features
      GetTaxPlanningSuggestionFeatures(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionFeatures/${mobileConfigId}`, callback, error);
      },
      CreateTaxPlanningSuggestionFeature(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionFeatures/${mobileConfigId}`, request, callback, error);
      },
      UpdateTaxPlanningSuggestionFeature(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionFeatures/${mobileConfigId}`, request, callback, error);
      },
      DeleteTaxPlanningSuggestionFeature(id, callback, error) {
        this.apiDeleteAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionFeatures/${id}`, callback, error);
      },
      GetTaxPlanningSuggestionActions(callback, error) {
        this.apiGetAuth('api/v0/TaxPlanningMobileConfiguration/SuggestionActions', callback, error);
      },

      // Tax Planning Suggestion Questions
      GetTaxPlanningSuggestionQuestions(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionQuestions/${mobileConfigId}`, callback, error);
      },
      CreateTaxPlanningSuggestionQuestion(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionQuestions/${mobileConfigId}`, request, callback, error);
      },
      UpdateTaxPlanningSuggestionQuestion(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionQuestions/${mobileConfigId}`, request, callback, error);
      },
      DeleteTaxPlanningSuggestionQuestion(id, callback, error) {
        this.apiDeleteAuth(`api/v0/TaxPlanningMobileConfiguration/SuggestionQuestions/${id}`, callback, error);
      },

      // Tax Planning Genie AI Characters
      GetTaxPlanningGenieAICharacters(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/TaxPlanningMobileConfiguration/GenieAICharacters/${mobileConfigId}`, callback, error);
      },
      CreateTaxPlanningGenieAICharacter(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/TaxPlanningMobileConfiguration/GenieAICharacters/${mobileConfigId}`, request, callback, error);
      },
      UpdateTaxPlanningGenieAICharacter(mobileConfigId, request, callback, error) {
        this.apiPutAuth(`api/v0/TaxPlanningMobileConfiguration/GenieAICharacters/${mobileConfigId}`, request, callback, error);
      },
      DeleteTaxPlanningGenieAICharacter(id, callback, error) {
        this.apiDeleteAuth(`api/v0/TaxPlanningMobileConfiguration/GenieAICharacters/${id}`, callback, error);
      },

      // Tax Planning dedicated uploads
      UploadTaxPlanningGenieCharacterIcon(request, callback, error) {
        let url = `api/v0/TaxPlanningMobileConfiguration/GenieAICharacters/UploadIcon?USER_CHANNEL=${request.USER_CHANNEL}&genieField=${request.genieField}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      UploadTaxPlanningImage(request, callback, error) {
        let url = `api/v0/TaxPlanningMobileConfiguration/UploadImage?USER_CHANNEL=${request.USER_CHANNEL}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      UploadTaxPlanningCif(request, callback, error) {
        this.apiPostImportFileAuth('api/v0/TaxPlanningMobileConfiguration/UploadCif', request, null, callback, error);
      },

      // Genie Prefix Voice upload
      UploadGeniePrefixMp3(request, callback, error) {
        let url = `api/v0/MobileConfiguration/GeniePrefixes/UploadMp3?createdAt=${encodeURIComponent(request.createdAt)}&genieField=${request.genieField}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      // Genie Prefix Patterns (Think Loader)
      SaveGeniePrefixPattern(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/MobileConfiguration/GeniePrefixPatterns/${mobileConfigId}`, request, callback, error);
      },
      DeleteGeniePrefixPattern(id, callback, error) {
        this.apiDeleteAuth(`api/v0/MobileConfiguration/GeniePrefixPatterns/${id}`, callback, error);
      },

      // Tax Prefix Voice upload
      UploadTaxPrefixMp3(request, callback, error) {
        let url = `api/v0/TaxPlanningMobileConfiguration/TaxPrefixes/UploadMp3?createdAt=${encodeURIComponent(request.createdAt)}&prefixField=${request.prefixField}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      // Tax Prefix Patterns
      GetTaxPrefixPatterns(mobileConfigId, callback, error) {
        this.apiGetAuth(`api/v0/TaxPlanningMobileConfiguration/TaxPrefixPatterns/${mobileConfigId}`, callback, error);
      },
      SaveTaxPrefixPattern(mobileConfigId, request, callback, error) {
        this.apiPostAuth(`api/v0/TaxPlanningMobileConfiguration/TaxPrefixPatterns/${mobileConfigId}`, request, callback, error);
      },
      DeleteTaxPrefixPattern(id, callback, error) {
        this.apiDeleteAuth(`api/v0/TaxPlanningMobileConfiguration/TaxPrefixPatterns/${id}`, callback, error);
      },

      // Account Info Management
      GetAccountInfos(callback, error) {
        this.apiGetAuth('api/v1/AccountInfo', callback, error);
      },
      GetAccountInfoById(id, callback, error) {
        this.apiGetAuth(`api/v1/AccountInfo/${id}`, callback, error);
      },
      CreateAccountInfo(request, callback, error) {
        this.apiPostAuth('api/v1/AccountInfo', request, callback, error);
      },
      UpdateAccountInfo(id, request, callback, error) {
        this.apiPutAuth(`api/v1/AccountInfo/${id}`, request, callback, error);
      },
      DeleteAccountInfo(id, callback, error) {
        this.apiDeleteAuth(`api/v1/AccountInfo/${id}`, callback, error);
      },

      // Account Tiers
      GetAccountTiers(accountId, callback, error) {
        this.apiGetAuth(`api/v1/AccountInfo/${accountId}/tiers`, callback, error);
      },
      CreateAccountTier(accountId, request, callback, error) {
        this.apiPostAuth(`api/v1/AccountInfo/${accountId}/tiers`, request, callback, error);
      },
      UpdateAccountTier(tierId, request, callback, error) {
        this.apiPutAuth(`api/v1/AccountInfo/tiers/${tierId}`, request, callback, error);
      },
      DeleteAccountTier(tierId, callback, error) {
        this.apiDeleteAuth(`api/v1/AccountInfo/tiers/${tierId}`, callback, error);
      },

      //AccountInfo Dropdown
      GetAccountInfoDropdownOptions(callback, error) {
        this.apiGetAuth('api/v1/AccountInfo/dropdown-options', callback, error);
      },

      // AccountInfo Subcategory Management
      GetAllSubCategories(callback, error) {
        this.apiGetAuth('api/v1/AccountInfo/subcategories', callback, error);
      },
      GetSubCategoriesByCategory(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountInfo/subcategories/category/${categoryId}`, callback, error);
      },
      CheckCategoryUsage(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountInfo/categories/${categoryId}/usage`, callback, error);
      },
      CheckSubCategoryUsage(subCategoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountInfo/subcategories/${subCategoryId}/usage`, callback, error);
      },

      // Category Management Usage Validation
      CheckAccountCategoryUsage(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountCategory/${categoryId}/usage`, callback, error);
      },
      CheckAccountSubCategoryUsage(subCategoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountSubCategory/${subCategoryId}/usage`, callback, error);
      },

      // Account Categories
      GetAccountCategories(callback, error) {
        this.apiGetAuth('api/v1/AccountCategory', callback, error);
      },
      GetAccountCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/AccountCategory/${id}`, callback, error);
      },
      GetAccountCategoryDropdown(callback, error) {
        this.apiGetAuth('api/v1/AccountCategory/dropdown', callback, error);
      },
      SearchAccountCategories(request, callback, error) {
        this.apiPostAuth('api/v1/AccountCategory/search', request, callback, error);
      },
      CreateAccountCategory(request, callback, error) {
        this.apiPostAuth('api/v1/AccountCategory', request, callback, error);
      },
      UpdateAccountCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/AccountCategory/${id}`, request, callback, error);
      },
      DeleteAccountCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/AccountCategory/${id}`, callback, error);
      },
      ReorderAccountCategories(request, callback, error) {
        this.apiPostAuth('api/v1/AccountCategory/reorder', request, callback, error);
      },

      // Tax Categories
      GetTaxCategories(callback, error) {
        this.apiGetAuth('api/v1/TaxCategory?includeInactive=true', callback, error);
      },
      GetActiveTaxCategories(callback, error) {
        this.apiGetAuth('api/v1/TaxCategory', callback, error);
      },
      GetTaxCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/TaxCategory/${id}`, callback, error);
      },
      CreateTaxCategory(request, callback, error) {
        this.apiPostAuth('api/v1/TaxCategory', request, callback, error);
      },
      UpdateTaxCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/TaxCategory/${id}`, request, callback, error);
      },
      DeleteTaxCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/TaxCategory/${id}`, callback, error);
      },
      ReorderTaxCategories(request, callback, error) {
        this.apiPostAuth('api/v1/TaxCategory/reorder', request, callback, error);
      },

      // Tax Consent
      GetTaxConsentVersions(callback, error) {
        this.apiGetAuth('api/v1/TaxConsent', callback, error);
      },
      GetTaxConsentLogs(callback, error) {
        this.apiGetAuth('api/v1/TaxConsent/logs', callback, error);
      },
      GetTaxConsentByCode(versionCode, callback, error) {
        this.apiGetAuth(`api/v1/TaxConsent/${versionCode}`, callback, error);
      },
      CreateTaxConsentVersion(request, callback, error) {
        this.apiPostAuth('api/v1/TaxConsent', request, callback, error);
      },
      UpdateTaxConsentVersion(id, request, callback, error) {
        this.apiPutAuth(`api/v1/TaxConsent/${id}`, request, callback, error);
      },
      SetTaxConsentActive(id, request, callback, error) {
        this.apiPutAuth(`api/v1/TaxConsent/${id}/active`, request, callback, error);
      },
      DuplicateTaxConsentActive(request, callback, error) {
        this.apiPostAuth('api/v1/TaxConsent/duplicate', request, callback, error);
      },
      UploadTaxConsentIcon(request, callback, error) {
        let url = `api/v1/TaxConsent/UploadIcon?USER_CHANNEL=${request.USER_CHANNEL}`;
        this.apiPostTypeFileNoResponseAuth(url, request.entity, callback, error);
      },
      DeleteTaxConsentVersion(id, callback, error) {
        this.apiDeleteAuth(`api/v1/TaxConsent/${id}`, callback, error);
      },

      // Tax CIF
      EncryptTaxCif(request, callback, error) {
        this.apiPostAuthNoAlert('api/v1/TaxCif/encrypt', request, callback, error);
      },

      DecryptTaxCif(request, callback, error) {
        this.apiPostAuthNoAlert('api/v1/TaxCif/decrypt', request, callback, error);
      },

      // [#929] { encryptedCifs: [...] } → data.items = [{ encryptedCif, decryptedCif }] (only the values that decrypt)
      DecryptTaxCifBatch(request, callback, error) {
        this.apiPostAuthNoAlert('api/v1/TaxCif/decrypt-batch', request, callback, error);
      },

      // Tax Years
      GetTaxYears(callback, error) {
        this.apiGetAuth('api/v1/TaxConfig/years?includeInactive=true', callback, error);
      },
      GetActiveTaxYears(callback, error) {
        this.apiGetAuth('api/v1/TaxConfig/years', callback, error);
      },
      GetTaxYearById(id, callback, error) {
        this.apiGetAuth(`api/v1/TaxConfig/years/${id}`, callback, error);
      },
      GetTaxYearByCode(code, callback, error) {
        this.apiGetAuth(`api/v1/TaxConfig/years/code/${encodeURIComponent(code)}`, callback, error);
      },
      CreateTaxYear(request, callback, error) {
        this.apiPostAuth('api/v1/TaxConfig/years', request, callback, error);
      },
      UpdateTaxYear(id, request, callback, error) {
        this.apiPutAuth(`api/v1/TaxConfig/years/${id}`, request, callback, error);
      },
      SetTaxYearActive(id, request, callback, error) {
        this.apiPatchAuth(`api/v1/TaxConfig/years/${id}/active`, request, callback, error);
      },
      DeleteTaxYear(id, callback, error) {
        this.apiDeleteAuth(`api/v1/TaxConfig/years/${id}`, callback, error);
      },

      // Tax Config Versions
      GetTaxConfigVersions(callback, error) {
        this.apiGetAuth('api/v1/TaxConfig/versions?includeInactive=true', callback, error);
      },
      GetTaxConfigVersionsByYear(yearId, callback, error) {
        this.apiGetAuth(`api/v1/TaxConfig/versions?includeInactive=true&yearId=${yearId}`, callback, error);
      },
      GetTaxConfigVersionById(id, callback, error) {
        this.apiGetAuth(`api/v1/TaxConfig/versions/${id}`, callback, error);
      },
      GetTaxConfigVersionByCode(yearId, code, callback, error) {
        this.apiGetAuth(`api/v1/TaxConfig/versions/year/${yearId}/code/${encodeURIComponent(code)}`, callback, error);
      },
      CreateTaxConfigVersion(request, callback, error) {
        this.apiPostAuth('api/v1/TaxConfig/versions', request, callback, error);
      },
      UpdateTaxConfigVersion(id, request, callback, error) {
        this.apiPutAuth(`api/v1/TaxConfig/versions/${id}`, request, callback, error);
      },
      SetTaxConfigVersionActive(id, request, callback, error) {
        this.apiPatchAuth(`api/v1/TaxConfig/versions/${id}/active`, request, callback, error);
      },
      DeleteTaxConfigVersion(id, callback, error) {
        this.apiDeleteAuth(`api/v1/TaxConfig/versions/${id}`, callback, error);
      },

      // Account Sub Categories
      GetAccountSubCategories(callback, error) {
        this.apiGetAuth('api/v1/AccountSubCategory', callback, error);
      },
      GetAccountSubCategories(callback, error) {
        this.apiGetAuth('api/v1/AccountSubCategory', callback, error);
      },
      GetAccountSubCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/AccountSubCategory/${id}`, callback, error);
      },
      GetSubCategoriesByCategory(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountSubCategory/category/${categoryId}`, callback, error);
      },
      GetSubCategoryDropdown(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/AccountSubCategory/dropdown/${categoryId}`, callback, error);
      },
      SearchAccountSubCategories(request, callback, error) {
        this.apiPostAuth('api/v1/AccountSubCategory/search', request, callback, error);
      },
      CreateAccountSubCategory(request, callback, error) {
        this.apiPostAuth('api/v1/AccountSubCategory', request, callback, error);
      },
      UpdateAccountSubCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/AccountSubCategory/${id}`, request, callback, error);
      },
      DeleteAccountSubCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/AccountSubCategory/${id}`, callback, error);
      },

      // Meta Account Categories
      GetMetaAccountCategories(callback, error) {
        this.apiGetAuth('api/v1/MetaAccountCategory', callback, error);
      },
      GetMetaAccountCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/MetaAccountCategory/${id}`, callback, error);
      },
      GetMetaAccountCategoryDropdown(callback, error) {
        this.apiGetAuth('api/v1/MetaAccountCategory/dropdown', callback, error);
      },
      SearchMetaAccountCategories(request, callback, error) {
        this.apiPostAuth('api/v1/MetaAccountCategory/search', request, callback, error);
      },
      CreateMetaAccountCategory(request, callback, error) {
        this.apiPostAuth('api/v1/MetaAccountCategory', request, callback, error);
      },
      UpdateMetaAccountCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/MetaAccountCategory/${id}`, request, callback, error);
      },
      DeleteMetaAccountCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/MetaAccountCategory/${id}`, callback, error);
      },
      CheckMetaAccountCategoryUsage(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/MetaAccountCategory/${categoryId}/usage`, callback, error);
      },
      ReorderMetaAccountCategories(request, callback, error) {
        this.apiPutAuth('api/v1/MetaAccountCategory/reorder', request, callback, error);
      },

      // Meta Account Sub Categories
      GetMetaAccountSubCategories(callback, error) {
        this.apiGetAuth('api/v1/MetaAccountSubCategory', callback, error);
      },
      GetMetaAccountSubCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/MetaAccountSubCategory/${id}`, callback, error);
      },
      GetMetaSubCategoriesByCategory(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/MetaAccountSubCategory/category/${categoryId}`, callback, error);
      },
      GetMetaSubCategoryDropdown(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/MetaAccountSubCategory/dropdown/${categoryId}`, callback, error);
      },
      SearchMetaAccountSubCategories(request, callback, error) {
        this.apiPostAuth('api/v1/MetaAccountSubCategory/search', request, callback, error);
      },
      CreateMetaAccountSubCategory(request, callback, error) {
        this.apiPostAuth('api/v1/MetaAccountSubCategory', request, callback, error);
      },
      UpdateMetaAccountSubCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/MetaAccountSubCategory/${id}`, request, callback, error);
      },
      DeleteMetaAccountSubCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/MetaAccountSubCategory/${id}`, callback, error);
      },
      CheckMetaAccountSubCategoryUsage(subCategoryId, callback, error) {
        this.apiGetAuth(`api/v1/MetaAccountSubCategory/${subCategoryId}/usage`, callback, error);
      },

      // Meta Document Categories (CRUD over existing MetaDocPrefixMapping rows where Level = "Category")
      GetMetaDocCategories(callback, error) {
        this.apiGetAuth('api/v1/MetaDocCategory', callback, error);
      },
      GetMetaDocCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocCategory/${id}`, callback, error);
      },
      GetMetaDocCategoryDropdown(callback, error) {
        this.apiGetAuth('api/v1/MetaDocCategory/dropdown', callback, error);
      },
      SearchMetaDocCategories(request, callback, error) {
        this.apiPostAuth('api/v1/MetaDocCategory/search', request, callback, error);
      },
      CreateMetaDocCategory(request, callback, error) {
        this.apiPostAuth('api/v1/MetaDocCategory', request, callback, error);
      },
      UpdateMetaDocCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/MetaDocCategory/${id}`, request, callback, error);
      },
      DeleteMetaDocCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/MetaDocCategory/${id}`, callback, error);
      },
      CheckMetaDocCategoryUsage(categoryId, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocCategory/${categoryId}/usage`, callback, error);
      },
      ReorderMetaDocCategories(request, callback, error) {
        this.apiPutAuth('api/v1/MetaDocCategory/reorder', request, callback, error);
      },

      // Meta Document Sub Categories (CRUD over existing MetaDocPrefixMapping rows where Level = "Type")
      GetMetaDocSubCategories(callback, error) {
        this.apiGetAuth('api/v1/MetaDocSubCategory', callback, error);
      },
      GetMetaDocSubCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocSubCategory/${id}`, callback, error);
      },
      GetMetaDocSubCategoriesByCategory(categoryTitle, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocSubCategory/category/${encodeURIComponent(categoryTitle)}`, callback, error);
      },
      GetMetaDocSubCategoryDropdown(categoryTitle, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocSubCategory/dropdown/${encodeURIComponent(categoryTitle)}`, callback, error);
      },
      SearchMetaDocSubCategories(request, callback, error) {
        this.apiPostAuth('api/v1/MetaDocSubCategory/search', request, callback, error);
      },
      CreateMetaDocSubCategory(request, callback, error) {
        this.apiPostAuth('api/v1/MetaDocSubCategory', request, callback, error);
      },
      UpdateMetaDocSubCategory(id, request, callback, error) {
        this.apiPutAuth(`api/v1/MetaDocSubCategory/${id}`, request, callback, error);
      },
      DeleteMetaDocSubCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v1/MetaDocSubCategory/${id}`, callback, error);
      },
      CheckMetaDocSubCategoryUsage(subCategoryId, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocSubCategory/${subCategoryId}/usage`, callback, error);
      },
      ReorderMetaDocSubCategories(categoryTitle, request, callback, error) {
        this.apiPutAuth(`api/v1/MetaDocSubCategory/category/${encodeURIComponent(categoryTitle)}/reorder`, request, callback, error);
      },

      // Meta Document Product Subtypes (CRUD over existing MetaDocPrefixMapping Level = "Subtype" rows)
      GetMetaDocProductSubtypesByCategory(productCategory, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocProductSubtype/category/${encodeURIComponent(productCategory)}`, callback, error);
      },
      GetMetaDocProductSubtypeById(id, callback, error) {
        this.apiGetAuth(`api/v1/MetaDocProductSubtype/${id}`, callback, error);
      },
      CreateMetaDocProductSubtype(request, callback, error) {
        this.apiPostAuth('api/v1/MetaDocProductSubtype', request, callback, error);
      },
      UpdateMetaDocProductSubtype(id, request, callback, error) {
        this.apiPutAuth(`api/v1/MetaDocProductSubtype/${id}`, request, callback, error);
      },
      DeleteMetaDocProductSubtype(id, callback, error) {
        this.apiDeleteAuth(`api/v1/MetaDocProductSubtype/${id}`, callback, error);
      },

      // DeepLink
      GetDeepLinks(includeInactive = false, callback, error) {
        const query = includeInactive ? '?includeInactive=true' : '';
        this.apiGetAuth(`api/v1/DeepLink${query}`, callback, error);
      },
      SearchDeepLinks(request, callback, error) {
        this.apiPostAuth('api/v1/DeepLink/search', request, callback, error);
      },
      GetDeepLinkById(id, callback, error) {
        this.apiGetAuth(`api/v1/DeepLink/${id}`, callback, error);
      },
      CreateDeepLink(request, callback, error) {
        this.apiPostAuth('api/v1/DeepLink', request, callback, error);
      },
      UpdateDeepLink(request, callback, error) {
        this.apiPutAuth(`api/v1/DeepLink`, request, callback, error);
      },
      DeleteDeepLink(id, callback, error) {
        this.apiDeleteAuth(`api/v1/DeepLink/${id}`, callback, error);
      },

      // Access Level Config (cus.AccessLevelConfig) — wording 3 ภาษาต่อท้าย :ACCESS_LEVEL_REQUIRED:
      GetAccessLevelConfig(callback, error) {
        this.apiGetAuth('api/v1/AccessLevelConfig', callback, error);
      },
      SaveAccessLevelConfig(request, callback, error) {
        this.apiPostAuth('api/v1/AccessLevelConfig/save', request, callback, error);
      },

      // AgentTool
      GetAgentTools(includeInactive = false, callback, error) {
        const query = includeInactive ? '?includeInactive=true' : '';
        this.apiGetAuth(`api/v1/AgentTool${query}`, callback, error);
      },
      SearchAgentTools(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool/search', request, callback, error);
      },
      GetAgentToolById(id, callback, error) {
        this.apiGetAuth(`api/v1/AgentTool/${id}`, callback, error);
      },
      CreateAgentTool(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool', request, callback, error);
      },
      UpdateAgentTool(request, callback, error) {
        this.apiPutAuth(`api/v1/AgentTool`, request, callback, error);
      },
      DeleteAgentTool(id, callback, error) {
        this.apiDeleteAuth(`api/v1/AgentTool/${id}`, callback, error);
      },

      // STT Logs
      GetSTTLogs(callback, error) {
        this.apiGetAuth('api/v1/STTLog', callback, error);
      },
      GetSTTLogById(id, callback, error) {
        this.apiGetAuth(`api/v1/STTLog/${id}`, callback, error);
      },
      SearchSTTLogs(request, callback, error) {
        this.apiPostAuth('api/v1/STTLog/search', request, callback, error);
      },
      CreateSTTLog(request, callback, error) {
        this.apiPostAuth('api/v1/STTLog', request, callback, error);
      },
      UpdateSTTLog(request, callback, error) {
        this.apiPutAuth('api/v1/STTLog', request, callback, error);
      },
      DeleteSTTLog(id, callback, error) {
        this.apiDeleteAuth(`api/v1/STTLog/${id}`, callback, error);
      },

      // GPT Logs
      GetGPTLogs(callback, error) {
        this.apiGetAuth('api/v1/GPTLog', callback, error);
      },
      GetGPTLogById(id, callback, error) {
        this.apiGetAuth(`api/v1/GPTLog/${id}`, callback, error);
      },
      SearchGPTLogs(request, callback, error) {
        this.apiPostAuth('api/v1/GPTLog/search', request, callback, error);
      },
      CreateGPTLog(request, callback, error) {
        this.apiPostAuth('api/v1/GPTLog', request, callback, error);
      },
      UpdateGPTLog(request, callback, error) {
        this.apiPutAuth('api/v1/GPTLog', request, callback, error);
      },
      DeleteGPTLog(id, callback, error) {
        this.apiDeleteAuth(`api/v1/GPTLog/${id}`, callback, error);
      },

      // TTS Logs
      GetTTSLogs(callback, error) {
        this.apiGetAuth('api/v1/TTSLog', callback, error);
      },
      GetTTSLogById(id, callback, error) {
        this.apiGetAuth(`api/v1/TTSLog/${id}`, callback, error);
      },
      SearchTTSLogs(request, callback, error) {
        this.apiPostAuth('api/v1/TTSLog/search', request, callback, error);
      },
      CreateTTSLog(request, callback, error) {
        this.apiPostAuth('api/v1/TTSLog', request, callback, error);
      },
      UpdateTTSLog(request, callback, error) {
        this.apiPutAuth('api/v1/TTSLog', request, callback, error);
      },
      DeleteTTSLog(id, callback, error) {
        this.apiDeleteAuth(`api/v1/TTSLog/${id}`, callback, error);
      },

      // CIF Zero Init Log
      SearchCifZeroInitLog(request, callback, error) {
        this.apiPostAuth('api/v1/CifZeroInitLog/search', request, callback, error);
      },

      // Chat Full Logs (Group level)
      SearchChatFullLogs(request, callback, error) {
        this.apiPostAuth('api/v1/ChatFullLog/search', request, callback, error);
      },
      CreateChatFullLog(request, callback, error) {
        this.apiPostAuth('api/v1/ChatFullLog', request, callback, error);
      },
      GetChatFullLog(id, callback, error) {
        this.apiGetAuth(`api/v1/ChatFullLog/${id}`, callback, error);
      },
      UpdateChatFullLog(request, callback, error) {
        this.apiPutAuth('api/v1/ChatFullLog', request, callback, error);
      },
      DeleteChatFullLog(id, callback, error) {
        this.apiDeleteAuth(`api/v1/ChatFullLog/${id}`, callback, error);
      },
      GetChatFullGroupDetails(groupId, callback, error) {
        this.apiGetAuth(`api/v1/ChatFullLog/group/${groupId}/details`, callback, error);
      },

      // Lexicon Management
      GetLexicons(language, includeInactive, callback, error) {
        const url = language ? `api/v1.0/Lexicon?language=${language}&includeInactive=${includeInactive}` : `api/v1.0/Lexicon?includeInactive=${includeInactive}`;
        this.apiGetAuth(url, callback, error);
      },
      BulkSaveChanges(request, callback, error) {
        this.apiPostAuth('api/v1.0/Lexicon/BulkSave', request, callback, error);
      },
      GetLexiconVersion(callback, error) {
        this.apiGetAuth('api/v1.0/Lexicon/Version', callback, error);
      },
      CheckLexiconVersion(currentVersion, callback, error) {
        this.apiPostAuth('api/v1.0/Lexicon/CheckVersion', { currentVersion }, callback, error);
      },

      // Target Phrase Management
      GetTargetPhrases(includeInactive, callback, error) {
        const url = `api/v1.0/TargetPhrase?includeInactive=${includeInactive}`;
        this.apiGetAuth(url, callback, error);
      },
      BulkSaveTargetPhraseChanges(request, callback, error) {
        this.apiPostAuth('api/v1.0/TargetPhrase/BulkSave', request, callback, error);
      },

      // Intent Master Data Management (D1)
      GetTableIntentMaster(request, callback, error) {
        this.apiPostAuth('api/v0/IntentMaster/GetTableIntentMaster', request, callback, error);
      },
      GetIntentMasterById(id, callback, error) {
        this.apiGetAuth(`api/v0/IntentMaster/GetIntentMasterById?id=${id}`, callback, error);
      },
      CreateIntentMaster(request, callback, error) {
        this.apiPostAuth('api/v0/IntentMaster/CreateIntentMaster', request, callback, error);
      },
      UpdateIntentMaster(request, callback, error) {
        this.apiPostAuth('api/v0/IntentMaster/UpdateIntentMaster', request, callback, error);
      },
      DeleteIntentMaster(id, callback, error) {
        this.apiDeleteAuth(`api/v0/IntentMaster/DeleteIntentMaster?id=${id}`, callback, error);
      },
      GetAllIntentCategories(callback, error) {
        this.apiGetAuth('api/v0/IntentMaster/GetAllIntentCategories', callback, error);
      },
      GetIntentCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v0/IntentMaster/GetIntentCategoryById?id=${id}`, callback, error);
      },
      CreateIntentCategory(request, callback, error) {
        this.apiPostAuth('api/v0/IntentMaster/CreateIntentCategory', request, callback, error);
      },
      UpdateIntentCategory(request, callback, error) {
        this.apiPostAuth('api/v0/IntentMaster/UpdateIntentCategory', request, callback, error);
      },
      DeleteIntentCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v0/IntentMaster/DeleteIntentCategory?id=${id}`, callback, error);
      },
      GetCategoryStats(callback, error) {
        this.apiGetAuth('api/v0/IntentMaster/GetCategoryStats', callback, error);
      },
      // Intent Hierarchy APIs (IntentRoutingTree)
      GetIntentLevel1(callback, error) {
        this.apiGetAuth('api/v0/IntentMaster/GetIntentLevel1', callback, error);
      },
      GetIntentLevel2(parentId, callback, error) {
        this.apiGetAuth(`api/v0/IntentMaster/GetIntentLevel2/${parentId}`, callback, error);
      },
      GetIntentLevel3(parentId, callback, error) {
        this.apiGetAuth(`api/v0/IntentMaster/GetIntentLevel3/${parentId}`, callback, error);
      },
      GetIntentLevel4(parentId, callback, error) {
        this.apiGetAuth(`api/v0/IntentMaster/GetIntentLevel4/${parentId}`, callback, error);
      },

      // Intent Test Job APIs (Validation Runner)
      CreateIntentTestJob(request, callback, error) {
        this.apiPostAuth('api/v0/IntentTestJob/CreateIntentTestJob', request, callback, error);
      },
      GetIntentTestJobById(id, callback, error) {
        this.apiGetAuth(`api/v0/IntentTestJob/GetIntentTestJobById/${id}`, callback, error);
      },
      GetTableIntentTestJob(request, callback, error) {
        this.apiPostAuth('api/v0/IntentTestJob/GetTableIntentTestJob', request, callback, error);
      },
      DeleteIntentTestJob(id, callback, error) {
        this.apiDeleteAuth(`api/v0/IntentTestJob/DeleteIntentTestJob/${id}`, callback, error);
      },
      UpdateIntentTestJob(id, request, callback, error) {
        this.apiPostAuth(`api/v0/IntentTestJob/UpdateIntentTestJob/${id}`, request, callback, error);
      },
      QueueIntentTestJob(id, callback, error) {
        this.apiPostAuth(`api/v0/IntentTestJob/QueueIntentTestJob/${id}`, null, callback, error);
      },
      CancelIntentTestJob(id, callback, error) {
        this.apiPostAuth(`api/v0/IntentTestJob/CancelIntentTestJob/${id}`, null, callback, error);
      },
      RerunIntentTestJob(id, callback, error) {
        this.apiPostAuth(`api/v0/IntentTestJob/RerunIntentTestJob/${id}`, null, callback, error);
      },
      GetIntentTestJobQueue(callback, error) {
        this.apiGetAuth('api/v0/IntentTestJob/GetIntentTestJobQueue', callback, error);
      },
      GetRunningIntentTestJob(callback, error) {
        this.apiGetAuth('api/v0/IntentTestJob/GetRunningIntentTestJob', callback, error);
      },
      GetIntentTestJobProgress(jobId, callback, error) {
        this.apiGetAuth(`api/v0/IntentTestJob/GetIntentTestJobProgress/${jobId}`, callback, error);
      },
      GetIntentTestJobRunHistory(id, callback, error) {
        this.apiGetAuth(`api/v0/IntentTestJob/GetIntentTestJobRunHistory/${id}`, callback, error);
      },
      GetTableIntentTestResult(request, callback, error) {
        this.apiPostAuth('api/v0/IntentTestJob/GetTableIntentTestResult', request, callback, error);
      },
      GetIntentTestJobSummary(jobId, callback, error) {
        this.apiGetAuth(`api/v0/IntentTestJob/GetIntentTestJobSummary/${jobId}`, callback, error);
      },
      ExportPythonJson(jobId, callback, error) {
        this.apiGetAuth(`api/v0/IntentTestJob/ExportPythonJson/${jobId}`, callback, error);
      },
      ExportSummaryReport(jobId, callback, error) {
        this.apiGetAuth(`api/v0/IntentTestJob/ExportSummaryReport/${jobId}`, callback, error);
      },

      // Validation V2 API Methods (NEW - Simplified)

      CreateValidationJob(request, callback, error) {
        this.apiPostAuth('api/v0/Validation/CreateJob', request, callback, error);
      },
      UpdateValidationJob(id, request, callback, error) {
        this.apiPutAuth(`api/v0/Validation/UpdateJob/${id}`, request, callback, error);
      },
      GetValidationJobById(id, callback, error) {
        this.apiGetAuth(`api/v0/Validation/GetJobById/${id}`, callback, error);
      },
      GetValidationJobByJobId(jobId, callback, error) {
        this.apiGetAuth(`api/v0/Validation/GetJobByJobId/${jobId}`, callback, error);
      },
      GetTableValidationJobs(request, callback, error) {
        this.apiPostAuth('api/v0/Validation/GetTableJobs', request, callback, error);
      },
      QueueValidationJob(id, callback, error) {
        this.apiPostAuth(`api/v0/Validation/QueueJob/${id}`, null, callback, error);
      },
      CancelValidationJob(id, callback, error) {
        this.apiPostAuth(`api/v0/Validation/CancelJob/${id}`, null, callback, error);
      },
      RerunValidationJob(id, callback, error) {
        this.apiPostAuth(`api/v0/Validation/RerunJob/${id}`, null, callback, error);
      },
      DeleteValidationJob(id, callback, error) {
        this.apiDeleteAuth(`api/v0/Validation/DeleteJob/${id}`, callback, error);
      },

      // Results
      GetValidationJobSummary(jobId, callback, error) {
        this.apiGetAuth(`api/v0/Validation/GetJobSummary/${jobId}`, callback, error);
      },
      GetTableValidationResults(request, callback, error) {
        this.apiPostAuth('api/v0/Validation/GetTableResults', request, callback, error);
      },
      GetValidationJobRunHistory(id, callback, error) {
        this.apiGetAuth(`api/v0/Validation/GetJobRunHistory/${id}`, callback, error);
      },
      GetValidationJobProgress(jobId, callback, error) {
        this.apiGetAuth(`api/v0/Validation/GetJobProgress/${jobId}`, callback, error);
      },

      // Queue Management
      GetRunningValidationJob(callback, error) {
        this.apiGetAuth('api/v0/Validation/GetRunningJob', callback, error);
      },
      GetValidationJobQueue(callback, error) {
        this.apiGetAuth('api/v0/Validation/GetJobQueue', callback, error);
      },

      // ValidationMaster API Methods (V2 - Master Data Management)

      // ValidationMaster CRUD
      GetTableValidationMaster(request, callback, error) {
        this.apiPostAuth('api/v0/ValidationMaster/GetTableValidationMaster', request, callback, error);
      },
      GetValidationMasterById(id, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetValidationMasterById?id=${id}`, callback, error);
      },
      CreateValidationMaster(request, callback, error) {
        this.apiPostAuth('api/v0/ValidationMaster/CreateValidationMaster', request, callback, error);
      },
      UpdateValidationMaster(request, callback, error) {
        this.apiPostAuth('api/v0/ValidationMaster/UpdateValidationMaster', request, callback, error);
      },
      DeleteValidationMaster(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationMaster/DeleteValidationMaster?id=${id}`, callback, error);
      },

      // IntentCategory Management (Shared)
      GetAllIntentCategories(callback, error) {
        this.apiGetAuth('api/v0/ValidationMaster/GetAllIntentCategories', callback, error);
      },
      GetAllValidationCategories(callback, error) {
        this.apiGetAuth('api/v0/ValidationMaster/GetAllIntentCategories', callback, error);
      },
      GetIntentCategoryById(id, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentCategoryById?id=${id}`, callback, error);
      },
      CreateIntentCategory(request, callback, error) {
        this.apiPostAuth('api/v0/ValidationMaster/CreateIntentCategory', request, callback, error);
      },
      UpdateIntentCategory(request, callback, error) {
        this.apiPostAuth('api/v0/ValidationMaster/UpdateIntentCategory', request, callback, error);
      },
      DeleteIntentCategory(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationMaster/DeleteIntentCategory?id=${id}`, callback, error);
      },

      // Category Stats
      GetCategoryStats(callback, error) {
        this.apiGetAuth('api/v0/ValidationMaster/GetCategoryStats', callback, error);
      },
      GetValidationCategoryStats(callback, error) {
        this.apiGetAuth('api/v0/ValidationMaster/GetCategoryStats', callback, error);
      },

      // Intent Hierarchy (Shared)
      GetIntentLevel1(callback, error) {
        this.apiGetAuth('api/v0/ValidationMaster/GetIntentLevel1', callback, error);
      },
      GetValidationIntentLevel1(callback, error) {
        this.apiGetAuth('api/v0/ValidationMaster/GetIntentLevel1', callback, error);
      },
      GetIntentLevel2(parentId, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentLevel2/${parentId}`, callback, error);
      },
      GetValidationIntentLevel2(parentId, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentLevel2/${parentId}`, callback, error);
      },
      GetIntentLevel3(parentId, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentLevel3/${parentId}`, callback, error);
      },
      GetValidationIntentLevel3(parentId, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentLevel3/${parentId}`, callback, error);
      },
      GetIntentLevel4(parentId, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentLevel4/${parentId}`, callback, error);
      },
      GetValidationIntentLevel4(parentId, callback, error) {
        this.apiGetAuth(`api/v0/ValidationMaster/GetIntentLevel4/${parentId}`, callback, error);
      },
    };
  },
};
// Vue.prototype.axios = axios;
// Vue.prototype.axios.defaults.headers.common['Authorization'] = "Bearer " + store.state.token;
// Vue.prototype.axios.defaults.headers['Content-Type'] = 'application/json';

// Vue.prototype.axios.defaults.headers.time =0;

export default APICall;
